<template>
	<article
		v-if="medref"
		class="article medref"
		:class="{'image-collection' : isImageCollection, 'policy-corp': isPolicyCorp,
			'fed-ia-art' : fedConfig, 'viewport_ads': viewportFlag }"
		:data-chronicle="chronicId"
		data-e2e="dart-medref"
		data-page="1"
		data-module-type="dynamic-article"
		:data-artId="metadataModule.i_chronicle_id"
		:style="fedStyle"
	>
		<!-- eslint-disable vue/no-v-text-v-html-on-component -->
		<script
			type="application/ld+json"
			v-html="jsonldVideo.json"
			v-if = "showInArticleVideo"
		></script>
		<script
			type="application/ld+json"
			v-html="jsonldData.json"
		></script>
		<!-- eslint-enable vue/no-v-text-v-html-on-component -->
		<div class="inner-article-container">
			<template v-if="!isInteractivePage || (isInteractivePage && isSiteFronts)">
				<div
					class="archive-popup-box"
					v-if="archive.showArchive && !isInteractivePage"
				>
					<button
						class="archive-tag"
						@click="showArchiveModal()"
					>
						<i class="webmd-archive-info-icon"></i>
						From the WebMD Archives
					</button>
					<!-- eslint-disable -->
					<WebmdDialog
						class="archive-dialog"
						v-model:visible="archive.modalVisible"
						center
					>
						<!-- eslint-enable -->
						<div v-html="archive.popupText"></div>
						<p v-if="archive.linkText">
							<a
								:href="archive.indexLink"
								v-html="archive.linkText"
							></a>
						</p>
					</WebmdDialog>
				</div>
				<LanguageToggle />
				<header v-if="(isMobile || isNewTabSpec) && isBlogArticle">
					<BlogHeader
						:moduledata="this.moduleByChronicId"
						:medrefdata="this.medref.medrefData"
					/>
				</header>
				<header v-else>
					<a
						class="fed-tag"
						:data-program-id="fedConfig.programid"
						v-if="fedConfig"
						:href="fedConfig.tocLink"
						v-metric="{module: 'ia-fed',link: 'toc'}"
					>
						{{ fedConfig.title }}
					</a>
					<div
						class="disclaimer-spon-text"
						v-if="infArticleNumber > 1 && fedConfig && (isMobile || isNewTabSpec)"
					>
						<span class="disc-text">
							Content independently created by WebMD and supported by our partners.
						</span>
						<a
							class="disc-link-text"
							href="https://www.webmd.com/about-webmd-policies/about-our-sponsors"
						>
							Learn More
						</a>
					</div>
					<h1 v-if="!isInteractivePage">
						{{ medref.medrefData.medrefTitle }}
					</h1>
					<!-- eslint-disable -->
					<img
						v-if="hasEmbeddedVideo"
						class="largeTempImg"
						style="pointer-events: none; position: absolute; top: 0; left: 0; width: 1000px; height: 2000px;"
						src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI5OTk5OXB4IiBoZWlnaHQ9Ijk5OTk5cHgiIHZpZXdCb3g9IjAgMCA5OTk5OSA5OTk5OSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9Ijk5OTk5IiBoZWlnaHQ9Ijk5OTk5Ij48L3JlY3Q+IDwvZz4gPC9zdmc+"
					/>
					<!-- eslint-enable -->
					<section
						class="publication-top"
						v-if="hideInArticle && (activePage === 1 || showPublicationSource) &&
							publDisplay && publDisplay.length > 0"
					>
						<span class="publication-display">
							{{ publDisplay }}
						</span>
						<img
							class="copyright-logo-top"
							v-if="publisherLogo && publisherLogo.src && publisherLogo.alt"
							:src="publisherLogo.src"
							:alt="publisherLogo.alt"
						/>
					</section>
					<p
						class="subhead"
						v-if="hideInArticle && subHeadLine"
					>
						{{ subHeadLine }}
					</p>
				</header>
				<div
					v-if="!isBlogArticle"
					class="med-wrap"
				>
					<div>
						<AssetReview
							:chronic-id="chronicId"
						/>
					</div>
				</div>
				<aside
					class="oncology-article-nav"
					v-if="isOncology && inThisArticle.length > 0"
					v-metric="{module: 'cwnav-art'}"
				>
					<ul
						class="nav-items desktop"
						:class="show"
					>
						<li
							v-for="(item, $index) in inThisArticle"
							:key="$index"
						>
							<a :href="item.href" v-metric="{link: ($index+1), type: 'ad-hoc'}">
								{{ item.text }}
							</a>
							<div
								v-if="inThisArticle.length > 4 && $index === 3"
								class="item-button"
								:class="{'close': show === 'anchor'}"
							>
								<a
									v-if="show !== 'anchor'"
									href="#"
									@click.prevent="toggle('anchor')"
								>
								</a>
							</div>
						</li>
						<li
							v-if="inThisArticle.length > 4"
							class="item-button"
							:class="{'open': show === 'anchor'}"
						>
							<a
								v-if="show === 'anchor'"
								href="#"
								@click.prevent="toggle('anchor')"
							>
							</a>
						</li>
					</ul>
				</aside>
			</template>
			<div
				class="reading-wrapper"
				v-if="!isBlogArticle"
			>
				<ReadingTime
					:html-content="medrefContentDesktop"
					:lang="localLang"
					v-if="!isPolicyCorp"
				/>
				<span
					v-if="hideReadMin"
					class="read-separator"
				>
					|
				</span>
				<div :id="'audio-placeholder-' + metadataModule.i_chronicle_id"></div>
			</div>
			<div
				v-if="hasEmbeddedVideo"
				class="preload-img-container"
			>
				<img
					fetchpriority="high"
					:src="getVideoPosterUrl"
					height="auto"
					width="100%"
				/>
			</div>
			<div
				v-if="hasEmbeddedVideo"
				class="video-wrapper"
			>
			</div>
			<template v-if="isInteractivePage">
				<div
					class="archive-popup-box"
					v-if="archive.showArchive"
				>
					<button
						class="archive-tag"
						@click="showArchiveModal()"
					>
						From the WebMD Archives
						<i class="webmd-icon-archive"></i>
					</button>
					<!-- eslint-disable -->
					<WebmdDialog
						class="archive-dialog"
						v-model:visible="archive.modalVisible"
						center
					>
						<!-- eslint-enable -->
						<div v-html="archive.popupText"></div>
						<p v-if="archive.linkText">
							<a
								:href="archive.indexLink"
								v-html="archive.linkText"
							></a>
						</p>
					</WebmdDialog>
				</div>
			</template>
			<!-- New Bundle Nav -->
			<BundleNav
				v-if="isBundleArticle && !isSiteFronts && !isOncology"
				:current-asset-id="metadataModule.i_chronicle_id"
			/>
			<div v-else-if="(!hideInArticle && !isPolicyCorp && !isOncology) && clientWidth > 1024">
				<aside
					:class="{
						'inline-in-art-nav' : (!hideInArticle && !isRDGSingleArticle && !isSiteFronts),
						'sf-in-article-nav': isSiteFronts,
						'in-article-nav': !isSiteFronts
					}"
					data-metrics-module="cwnav-art"
					data-metrics-sel="li"
					v-if="inThisArticle.length > 0"
				>
					<h4
						v-if="isRDGSingleArticle"
						class="rdg-ygt"
					>
						Your Guide To
					</h4>
					<h3 v-if="isRDGSingleArticle">
						{{ medref.medrefData.medrefTitle }}
					</h3>
					<h3 v-else>
						In this Article
					</h3>
					<ul>
						<li
							v-for="(item, index) in inThisArticle"
							:key="index"
						>
							<a
								:data-link="item.dataLink"
								:data-metrics-link="`cwnav-art_${item.section}`"
								:href="item.href"
							>
								{{ item.text }}
							</a>
						</li>
					</ul>
				</aside>
			</div>
			<div
				class="article__body"
				ref="articleBody"
				v-metric="{ module: 'embd-lnk' }"
				v-html="medrefContentDesktop"
			></div>
			<div
				class="next-art-nav-ai ai-modules"
				:id="`ai-mod-${metadataModule.i_chronicle_id}`"
				v-if="aiTestFlag"
			>
				<next-article-nav-ai
					:next-article-data="nextArticle"
					:topic-name="medref.medrefMetaData.about"
					v-if="aiTestNextArt"
				/>
				<PromotionalSearchModule/>
			</div>
			
			<div
				class="related-articles"
				v-metric="{module: 'cwnav-art', sel: 'li'}"
			>
				<ul
					class="related-items"
					v-if="isBundleArticle && bundle && bundle.assets.length > 0"
				>
					<span>RELATED ARTICLES:</span>
					<li
						v-for="(item, $index) in bundle.assets"
						:key="$index"
					>
						<a :href="item.link">
							{{ item.text }}
						</a>
					</li>
				</ul>
				<ul
					class="related-items"
					v-if="isLegacyBundleArticle && getLegacyBundleData.length > 0"
				>
					<span>RELATED ARTICLES:</span>
					<li
						v-for="(item, $index) in getLegacyBundleData"
						:key="$index"
					>
						<a :href="item.link">
							{{ item.text }}
						</a>
					</li>
				</ul>
			</div>
			<footer>
				<div class="pub-info-and-share-bar">
					<div
						v-if="!isPolicyCorp"
						class="article__publication-sources"
					>
						<AssetFooter />
					</div>
				</div>
			</footer>
			<!-- Next / Related article bottom module -->
			<div v-if="turnOffInfinite || !isInfinite || isFlowingFromNews || (!isMobile && !isNewTabSpec)">
				<NextArticleNavigation
					:next-article-data="nextArticle"
				/>
			</div>
			<div v-if="prSrchmodDsktp">
				<PromotionalSearchModule/>
			</div>
			<div
				id="unpaginated-article"
				v-if="!isMobile && viewAllContent"
			>
			</div>
			<div
				id="rc-tp-module"
				v-if="isInfinite"
			>
			</div>
			<SetRendered
				:chronic-id="chronicId"
				:data="this.moduleByChronicId"
				:article-type="this.medref.medrefData.contentSectionType"
				:related-linksdata="this.relatedLinksdata"
				:is-image-collection="this.isImageCollection"
				:is-site-fronts="this.isSiteFronts"
			/>
		</div>
	</article>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

import _has from 'lodash/has';
import _isArray from 'lodash/isArray';
import _get from 'lodash/get';
import _isObject from 'lodash/isObject';
import _pick from 'lodash/pick';
import { createApp, defineAsyncComponent, h } from 'vue';
import { mapState } from 'pinia';
import iaAd from 'webmd-ia-ad/src/Component.vue';
import iaMediaNetLnk from 'IA-MediaNetLink/src/Component.vue';
import webmdIAModule from 'webmd-ia-module/src/Component.vue';
import AssetReview from 'webmd-asset-medical-review/src/Component.vue';
import LanguageToggle from 'language-toggle/src/Component.vue';
import audioPlayer from 'webmd-audio-player/src/Component.vue';

// eslint-disable-next-line import/no-unresolved
import { Dialog } from 'webmd-elements';
import { ua } from 'webmd-useragent/index.es6';
import offsiteLinks from 'webmd-offsite/index.es6';
import metric from 'webmd-vuejs-metrics';
import instreamRelatedModule from 'webmd-instream-related-module/src/Component.vue';
import NextArticleNavAi from 'next-article-nav-ai/src/Component.vue';
import instreamFeaturedModule from 'instream-featured-module/src/Component.vue';
// eslint-disable-next-line import/no-unresolved
import PromotionalSearchModule from 'promotional-search-module/src/Component.vue';
import embededModulesMixin from './mixins/embededModules.mixins.es6';

// eslint-disable-next-line import/no-cycle
import infiniteArticleMixin from './mixins/infiniteArticle.mixins.es6';
import viewportAdsMixin from './mixins/viewportAds.mixins.es6';
import rrAdsMixin from './mixins/rrAds.mixins.es6';
import metadataMixin from './mixins/metadata.mixins.es6';
import SetRendered from './components/SetRendered.vue';
import ReadingTime from './components/ReadingTime.vue';
import BlogHeader from './components/blogHeader.vue';

export default {
	name: 'MedicalReference',
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		infArticleNumber: {
			type: Number,
			default: 1,
		},
		fedConfig: {
			type: Object,
			required: false,
		},
		isDev: {
			type: Boolean,
			default: false,
		},
		isInteractive: {
			type: Boolean,
			required: false,
			default: undefined,
		},
		nextArticleSource: {
			type: String,
			required: false,
			default: null,
		},
		isBlogArticle: {
			type: Boolean,
			default: false,
		},
		isFlowingFromNews: {
			type: Boolean,
			default: false,
		},

	},
	// eslint-disable-next-line max-len
	mixins: [metadataMixin, embededModulesMixin, infiniteArticleMixin, viewportAdsMixin, offsiteLinks, rrAdsMixin],

	components: {
		AssetReview,
		AssetFooter: defineAsyncComponent(() => import(/* webpackChunkName: "non-critical" */'webmd-asset-footer/src/Component.vue')),
		BlogHeader,
		LanguageToggle,
		NextArticleNavAi,
		ReadingTime,
		WebmdDialog: Dialog,
		BundleNav: defineAsyncComponent(() => import(/* webpackChunkName: "load-dynamic" */'./components/BundleNav.vue')),
		NextArticleNavigation: defineAsyncComponent(() => import(/* webpackChunkName: "non-critical" */'./components/NextArticleNavigation.vue')),
		SetRendered,
		audioPlayer,
		PromotionalSearchModule,		
	},

	data() {
		return {
			medref: {
				medrefData: {},
				medrefMetaData: {},
			},
			nextArtData: {},
			moduleData: {},
			embedVideoId: [],
			pageIndex: 1,
			embededModuleObject: null,
			nextArticle: false,
			medrefContentDesktop: '',
			medrefContentMobile: '',
			medrefParseEmbed: '',
			moduleByChronicId: {},
			totalPagesDesktop: 1,
			totalPagesMobile: 1,
			activePage: 1,
			inThisArticle: [],
			inThisArticleMobile: [],
			isNewsArticle: false,
			isMobile: false,
			isTablet: false,
			isEmbdAdFits: false,
			isWebMDcopyright: false,
			metricsModule: 'pagenum-art',
			inArticleMetricsModule: 'cwnav-art',
			sharethroughSlots: {
				1923: 'Vjx59uEm8EVWkMyP8f8smvF8',
				923: 'Vjx59uEm8EVWkMyP8f8smvF8',
				2026: 'JP2PR9q6cJCLZtj36uN7K5cd',
			},
			icmLoaded: false,
			jsonldVideo: {
				'@context': 'http://schema.org/',
				'@type': 'VideoObject',
				name: '',
				description: '',
				uploadDate: '',
				duration: '',
				contentUrl: '',
				thumbnailUrl: '',
				inLanguage: '',
				transcript: '',
			},
			jsonldData: {
				'@context': 'http://schema.org/',
				'@type': 'MedicalWebPage',
				mainEntityOfPage: '',
				lastReviewed: '',
				reviewedBy: {
					'@type': 'Person',
					name: '',
				},
				about: '',
				datePublished: '',
				headline: '',
				author: {
					'@type': 'Person',
					name: '',
				},
				dateModified: '',
				primaryImageOfPage: {
					'@type': 'ImageObject',
					name: '',
					description: '',
					license: '',
					url: '',
					thumbnailUrl: '',
				},
				publisher: {
					'@type': 'Organization',
					name: 'WebMD',
					logo: {
						'@type': 'ImageObject',
						url: '',
					},
				},
			},
			isBundleArticle: false,
			isLegacyBundleArticle: false,
			hideInArticle: false,
			isRDGSingleArticle: false,
			publDisplay: '',
			showPublicationSource: false,
			archive: {
				showArchive: false,
				modalVisible: false,
				popupText: '',
				linkText: '',
				indexLink: '',
			},
			subHeadLine: '',
			publisherLogo: {
				src: '',
				alt: '',
			},
			hasEmbeddedVideo: false,
			previousLink: '',
			nextLink: '',
			relatedLinksdata: '',
			isImageCollection: false,
			articleHeroImage: '',
			heroImgResize: {
				mobile: '?resize=320px:*&output-quality=75',
				desktop: '?resize=646px:*&output-quality=75',
			},
			imgCollectionResize: '?resize=646px:*&output-quality=75',
			videoThumbnailImage: '',
			embedImagePath: '',
			mainImageURL: '',
			desktopOffset: 350,
			seriesLabel: '',
			desktopVideoPosterResize: '?resize=750px:*&output-quality=35',
			show: false,
			qap: false,
			artNum: 1,
			viewAllContent: true,
			aiTestFlag: false,
			aiTestNextArt: false,
			prSrchmodDsktp: false,
			embededModuleObjectType: null,
			hideReadMin: false,
			turnOffInfinite: false,
			isSourceNews: false,
			localLang: '',
			attemptCount: 1,
			adCheckCount: 1,
			isNewTabSpec: false,
			ecdQuery: '',
			clientWidth: 320,
			showInArticleVideo: false,
		};
	},

	computed: {
		...mapState(useStore, {
			isInteractivePage(store) {
				if (this.isInteractive !== undefined) {
					return this.isInteractive;
				}
				return store.cms.isInteractivePage;
			},
		}),

		unpaginatedArticleLoader() {
			// eslint-disable-next-line no-underscore-dangle
			return defineAsyncComponent(() => import(/* webpackChunkName: "load-dynamic" */'webmd-unpaginated-article/src/Component.vue'))
				.__asyncLoader();
		},
		videoComponentLoader() {
			return defineAsyncComponent(() => import(/* webpackChunkName: "load-dynamic" */'vuejs-video-player/src/Component.vue'));
		},
		embededAssetsLoader() {
			return defineAsyncComponent(() => import(/* webpackChunkName: "load-dynamic" */'article-embedded-component/src/embeded-components/EmbededWrapper.vue'));
		},
		getModuleByChronicId() {
			const module = this.store.cms.getModules('articleModule') || this.store.cms.getModules(this.chronicId);
			return module;
		},

		getNextAsset() {
			return this.store.flow.getNextAssetInfo(this.metadataModule.i_chronicle_id);
		},

		getItems() {
			if (!this.moduleByChronicId) {
				return [];
			}
			const module = this.moduleByChronicId;
			let subHeadLine = '';
			let contentSectionType = '';
			let articleData = '';

			if (_has(module, 'module_data.content_section.cons_health_ref')) {
				articleData = module.module_data.content_section.cons_health_ref;
				contentSectionType = 'module_data.content_section.cons_health_ref';
			} else if (_has(module, 'module_data.content_section.cons_feature')) {
				articleData = module.module_data.content_section.cons_feature;
				contentSectionType = 'module_data.content_section.cons_feature';
				subHeadLine = module.module_data.content_section.cons_feature.subheadline
					? module.module_data.content_section.cons_feature.subheadline : '';
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.hideInArticle = true;
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			} else if (_has(module, 'module_data.content_section.cons_import_health_ref')) {
				articleData = module.module_data.content_section.cons_import_health_ref;
				contentSectionType = 'module_data.content_section.cons_import_health_ref';
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.hideInArticle = true;
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			} else if (_has(module, 'module_data.content_section.cons_news')) {
				articleData = module.module_data.content_section.cons_news;
				contentSectionType = 'module_data.content_section.cons_news';
				subHeadLine = module.module_data.content_section.cons_news.subheadline
					? module.module_data.content_section.cons_news.subheadline : '';
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.hideInArticle = true;
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.isNewsArticle = true;
			} else if (_has(module, 'module_data.content_section.cons_bio')) {
				articleData = module.module_data.content_section.cons_bio;
				contentSectionType = 'module_data.content_section.cons_bio';
			} else if (_has(module, 'module_data.content_section.cons_product')) {
				articleData = module.module_data.content_section.cons_product;
				contentSectionType = 'module_data.content_section.cons_product';
			} else if (module) {
				articleData = '';
				contentSectionType = '';
			}

			return {
				medrefData: {
					medrefTitle: (articleData && articleData.title) ? articleData.title : '',
					medrefContent: (articleData && articleData.section_groups) ? articleData.section_groups : '',
					subHeadLine,
					contentSectionType,
					mainImagePath: (articleData && _has(articleData, 'media_asset.path')) ? articleData.media_asset.path : '',
					mainImageAlt: (articleData && _has(articleData, 'media_asset.wbmd_c_alt_tag')) ? articleData.media_asset.wbmd_c_alt_tag : '',
					thumbnailImage: (articleData && _has(articleData, 'thumbnail_image')) ? articleData.thumbnail_image : '',
				},
			};
		},
		getMetaData() {
			const module = this.moduleByChronicId;

			const metadata = module && _has(module, 'module_settings.metadata_section')
				? module.module_settings.metadata_section : {};
			return metadata;
		},
		getMetaDataDetail() {
			if (!this.metadataModule) {
				return {};
			}
			const metadata = this.metadataModule;

			const desc = this.isNewsArticle ? this.store.pagedata.meta.og_tags.description : '';

			const imagepath = this.isNewsArticle ? this.store.pagedata.meta.og_tags.image : '';
			const isnewsArticle = this.isNewsArticle;

			const mainEntityOfPage = this.getFriendlyUrl();
			const lastReviewed = this.getReviewDate(metadata);
			const reviewedBy = this.getReviewerDetails(metadata);
			const archivePopup = this.getArchivePopup();

			const about = metadata && _has(metadata, 'wbmd_c_prim_top_id.wbmd_disp_nm')
				? metadata.wbmd_c_prim_top_id.wbmd_disp_nm : '';

			const datePublished = metadata && _has(metadata, 'wbmd_orig_pub_dt')
				? metadata.wbmd_orig_pub_dt : '';

			const headline = metadata && _has(metadata, 'title')
				? metadata.title : '';

			const author = metadata && (_has(metadata, 'wbmd_authr_prim_group.wbmd_authr_prim') ? this.getAuthorDetails(metadata.wbmd_authr_prim_group.wbmd_authr_prim) : []);
			const secondAuthor = metadata && (_has(metadata, 'wbmd_c_sec_authr_group.wbmd_c_sec_authr') ? this.getAuthorDetails(metadata.wbmd_c_sec_authr_group.wbmd_c_sec_authr) : []);
			const publisherLogo = this.getPublisherLogo(metadata);

			return {
				isnewsArticle,
				mainEntityOfPage,
				lastReviewed,
				reviewedBy,
				about,
				datePublished,
				headline,
				author,
				publisherLogo,
				secondAuthor,
				archivePopup,
				imagepath,
				desc,
			};
		},
		isInfinite() {
			return this.store.flow.isInfinite;
		},
		isSiteFronts() {
			const sfData = this.store.cms.siteFronts;
			if (_has(sfData, 'mode')) {
				return sfData.mode.toLowerCase() === 'sitefronts';
			}
			return false;
		},
		getSeriesLabel() {
			const module = this.store.cms.getModules('shared_object');

			const moduleTitle = module
			&& _has(module, 'Bundle_Article_Data.metadata_section.title')
				? module.Bundle_Article_Data.metadata_section.title
				: '';

			return moduleTitle;
		},
		getVideoPosterUrl() {
			// these styles are meant video in desktop mode
			if (this.jsonldVideo.thumbnailUrl) {
				const posterImg = this.jsonldVideo.thumbnailUrl + this.desktopVideoPosterResize;
				return posterImg;
			}
			return '';
		},
		fedStyle() {
			if (this.fedConfig && this.fedConfig.styleguide) {
				return {
					'--fed-theme-color': this.fedConfig.styleguide.pe_1,
					'--fed-text-color': this.fedConfig.styleguide.he_1,
				};
			}
			return '';
		},
		isPolicyCorp() {
			const metaData = this.metadataModule;
			const pubName = metaData && _has(metaData, 'wbmd_publ.wbmd_publ_name')
				? metaData.wbmd_publ.wbmd_publ_name : '';
			const pubNames = ['WebMD Policy', 'WebMD Corporate', 'WebMD Press Release', 'WebMD Policy - Spanish'];

			return pubNames.includes(pubName);
		},

		getLegacyBundleData() {
			const module = this.store.cms.getModules('shared_object');

			// short circuit if module malformed
			if (Object.keys(module).length === 0) {
				return [];
			}

			const items = module
			&& _has(module, 'Bundle_Article_Data.content_section.cons_topic_outline')
			&& _has(module, 'Bundle_Article_Data.content_section.cons_topic_outline.section_groups')
			&& _has(module, 'Bundle_Article_Data.content_section.cons_topic_outline.section_groups.section_group')
			&& _isArray(module.Bundle_Article_Data.content_section.cons_topic_outline
				.section_groups.section_group)
				? module.Bundle_Article_Data.content_section.cons_topic_outline
					.section_groups.section_group.map((link) => ({
						text: link.section_title || '',
						// eslint-disable-next-line no-underscore-dangle
						link: link.section_link.link_friendlyUrl || '',
						/* eslint no-underscore-dangle: ["error", { "allow": ["_chronic_id"] }] */
						chronicId: link.section_link._chronic_id || '',
					}))
				: [];

			return items;
		},
		bundle() {
			return this.store.flow.flowInfo.articleBundle || false;
		},
		isOncology() {
			return this.store.pagedata.isOncology;
		},

		getCategories() {
			let categories = [];
			if (_has(this.moduleByChronicId, 'module_settings.metadata_section.wbmd_secnd_category_group.wbmd_secnd_category')) {
				const wbmd_secnd_category = this.moduleByChronicId?.module_settings?.metadata_section?.wbmd_secnd_category_group?.wbmd_secnd_category;
				if (wbmd_secnd_category) {
					if (Array.isArray(wbmd_secnd_category)) {
						categories = wbmd_secnd_category.map((category) => ({
							storage_val: category.wbmd_storage_val,
							disp_nm: category.wbmd_disp_nm,
						}));
					} else {
						categories = [
							{
								storage_val: wbmd_secnd_category.wbmd_storage_val,
								disp_nm: wbmd_secnd_category.wbmd_disp_nm,
							},
						];
					}
				}
			}
			return categories;
		},
	},
	methods: {
		/*
		 * insertFirstAd(actStr, idx, rem, str) {
		 * 	return actStr.slice(0, idx) + str + actStr.slice(idx + Math.abs(rem));
		 * },
		 */
		handleScroll() {
			this.articlePages = document.querySelectorAll('.article__body .article-page');
			// eslint-disable-next-line max-len
			if (this.articlePages && this.articlePages.length && this.pageIndex && this.articlePages[this.pageIndex]) {
				this.pageNum = this.articlePages[this.pageIndex].attributes['data-page'].value;
				const targetEle = `.article-page[data-page="${this.pageNum}"]`;
				const targetElement = document.querySelector(targetEle);
				const scrollY = targetElement.offsetTop - ((parseInt(window.innerHeight / 2, 10))
					+ this.desktopOffset);

				if (targetElement) {
					if (scrollY && scrollY > 0 && window.pageYOffset > scrollY && !this.isTopAdlazyLoaded) {
						this.pageIndex += 1;
						if (this.pageIndex === this.articlePages.length) {
							this.pageIndex -= 1;
							this.isTopAdlazyLoaded = true;
							window.removeEventListener('scroll', this.handleScroll);
						}

						this.pageNum = parseInt(this.pageNum, 10);
						if (window && window.webmd && window.webmd.ads && !window.rrAdsNew) { // eslint-disable-line
							if (this.isInteractivePage && this.clientWidth > 1024) {
								// eslint-disable-next-line no-undef
								window.webmd.ads.refresh({ pos: 121 });
							}
						}

						if (this.pageNum === 2) {
							const divCont = document.createElement('div');
							const centerWellAd = document.getElementById('ad-centerwell-pos-141-2');
							const desktopIaSlot = createApp(webmdIAModule, {
								moduleId: 26,
							}).use(this.$pinia);

							if (centerWellAd) {
								centerWellAd.insertAdjacentElement('beforebegin', divCont);
								desktopIaSlot.mount(divCont);
							} else {
								this.placeElementInMiddle(targetElement, divCont, desktopIaSlot);
							}
						}

						if (!this.isInteractivePage) {
							const centeradSel = (this.isTablet || this.isEmbdAdFits) ? `ad-centerwell-pos-923-${this.pageNum}` : `ad-centerwell-pos-141-${this.pageNum}`;
							const topadId = (this.isTablet || this.isEmbdAdFits) ? `ad-top-pos-923-${this.pageNum}` : `ad-top-pos-141-${this.pageNum}`;
							const rr121AdId = `ads2-pos-121-ad-right-rr${this.pageNum}`;
							const rr137AdId = `ads2-pos-137-ad-right-rr${this.pageNum}`;
							const rRContainer = document.querySelector('div.main-container.main-container-3');
							const elength = rRContainer.children.length - 1;
							const rRLastElid = rRContainer.children[elength].getAttribute('id');
							let mtop;
							let mtoph;
							const adsobj = {};

							if (!window.rrAdsNew) {
								this.unpaginatedArticleLoader.then((comp) => {
									if (!this.qap) {
										// eslint-disable-next-line max-len
										comp.methods.createRRContainers(this.pageNum, this.isOncology, this.isSiteFronts);
									}
									const centerAdEle = document.getElementById(centeradSel);
									if (this.isTablet || this.isEmbdAdFits) {
										this.load923Ad(topadId);
										if (centerAdEle) {
											centerAdEle.classList.add('ad-923');
											this.load923Ad(centeradSel);
										}
									} else {
										comp.methods.load141Ad(topadId, this.pageNum);

										if (centerAdEle) {
											comp.methods.load141Ad(centeradSel, this.pageNum);
										}
									}
									if (!this.qap) {
										comp.methods.load121Ad(rr121AdId);
										comp.methods.load137Ad(rr137AdId);
									}
									if (window && window.webmd && window.webmd.ads) {
										window.webmd.ads.setPageTarget('pg', this.pageNum);
									}
								});
								/* eslint-disable no-undef */
								if (window && window.webmd && window.webmd.ads && (window.webmd.ads.disableAdsInit || window.webmd.ads.initialLoadDisabled)) {
									adsobj[topadId] = true;
									adsobj[rr121AdId] = true;
									adsobj[rr137AdId] = true;
									adsobj[centeradSel] = true;

									this.checkAndRefreshAds(adsobj, '', this.pageNum);
								}
							}

							if (window.googletag) {
								this.unpaginatedArticleLoader.then(() => {
									if (this.pageNum === 2) {
										const pageSel = `.article__body .article-page[data-page="${this.pageNum}"]`;
										const pageSelElement = document.querySelector(pageSel);

										/* Method to create a Related instream, module manager based */
										if (!this.isPolicyCorp) {
											this.createRelatedModule(pageSel, this.pageNum);
										}
										if (!window.rrAdsNew) {
											const selector = `ads2-pos-121-ad-right-rr-container${this.pageNum}`;
											const pos121AdSel = document.getElementById(selector);
											const rrLastElement = document.getElementById(rRLastElid);
											// eslint-disable-next-line max-len
											mtop = (pageSelElement && pageSelElement.offsetTop) - (rrLastElement.offsetTop + rrLastElement.offsetHeight);

											if (this.isOncology) {
												if (pos121AdSel) {
													pos121AdSel.style.minHeight = '800px';
												}
											}
											// eslint-disable-next-line max-len
											if (mtop > 1) {
												mtop += 25;
												pos121AdSel.style.marginTop = `${mtop}px`;
											}
										}
									} else if (this.pageNum >= 3) {
										const topPicSel = (this.isTablet || this.isEmbdAdFits) ? `.article__body .article-page[data-page="${this.pageNum}"]` : `#top-picks-mod-${this.pageNum}`;
										const pageSel = `.article__body .article-page[data-page="${this.pageNum}"]`;

										/* Method to create a Related instream, module manaager based */
										if (!this.isPolicyCorp) {
											this.createRelatedModule(pageSel, this.pageNum);
										}

										if (!window.rrAdsNew) {
											const prevPageNum = this.pageNum - 1;
											const rcForYouEle = `ed-rcmmnddforyou-${prevPageNum}`;
											const pos121Ad = `ads2-pos-121-ad-right-rr-container${this.pageNum}`;
											const pos121AdSel = document.getElementById(pos121Ad);
											const pageSelEle = document.querySelector(pageSel);
											const topPicSelEle = document.querySelector(topPicSel);
											const rrRcForYou = document.getElementById(rcForYouEle);
											if (this.isOncology) {
												const pos137Ad = `ads2-pos-137-ad-right-rr-container${prevPageNum}`;
												const pos137AdSel = document.getElementById(pos137Ad);
												// eslint-disable-next-line max-len
												mtoph = (pageSelEle && pageSelEle.offsetTop) - (pos137AdSel.offsetTop + pos137AdSel.offsetHeight);
												if (mtoph > 1) {
													mtoph += 25;
													pos121AdSel.style.marginTop = `${mtoph}px`;
												}

												if (pos121AdSel) {
													pos121AdSel.style.minHeight = '800px';
												}
											} else {
												// eslint-disable-next-line max-len
												mtoph = topPicSelEle && topPicSelEle.offsetTop - (rrRcForYou.offsetTop + rrRcForYou.offsetHeight);
												if (mtoph > 1) {
													mtoph += 25;
													pos121AdSel.style.marginTop = `${mtoph}px`;
												}
											}
										}
									}
								});
							}
						}
					}
				}
			}
		},

		loadDesktopAds (pageNum, direction) {
			let adsObj = {};
			let topadId = `ad-top-pos-141-${pageNum}`;
			let centeradSel = `ad-centerwell-pos-141-${pageNum}`;
			let rr121AdId = `ads2-pos-121-ad-right-rr${pageNum}`;
			let rr137AdId = `ads2-pos-137-ad-right-rr${pageNum}`;
			if (parseInt(pageNum, 10) === 1) {
				centeradSel = `ad-centerwell-pos-141-${pageNum}`;
				rr121AdId = `ad-pos-121-${pageNum}`;
				rr137AdId = `ad-pos-137-${pageNum}`;
				adsObj[centeradSel] = true;
				adsObj[rr121AdId] = true;
				adsObj[rr137AdId] = true;
			} else {
				adsObj[topadId] = true;
				adsObj[centeradSel] = true;
				adsObj[rr121AdId] = true;
				adsObj[rr137AdId] = true;
			}
			this.checkAndRefreshAds(adsObj, direction, pageNum);
		}, 

		viewAll() {
			this.activePage = this.totalPagesDesktop;
			this.showPublicationSource = true;
			[...document.querySelectorAll('.article__body .article-page')].forEach((el) => {
				if (!el.classList.contains('active-page')) {
					el.classList.add('active-page');
				}
				const pageNum = el.getAttribute('data-page');
				const targetElement = `.article-page[data-page="${pageNum}"] > section:nth-child(1)`;
				if (!this.isNewTabSpec) {
					// eslint-disable-next-line max-len
					if (pageNum >= 2 && (this.viewAllContent || (this.isSiteFronts && !this.isInteractivePage)) && this.clientWidth > 767 && !this.isPolicyCorp && !window.rrAdsNew) {
						this.unpaginatedArticleLoader.then((comp) => {
							comp.methods.createAdContainers(pageNum, targetElement);
						});
					}

					if (pageNum >= 2 && this.clientWidth > 1024 && !this.isPolicyCorp && window.hpTopicsRRTest) {
						this.unpaginatedArticleLoader.then((comp) => {
							comp.methods.createAdContainers(pageNum, targetElement);
						});
					}
				}
			});
		},
		placeElementInMiddle(elWrapper, elementToPlace, mountable) {
			const sections = [...elWrapper.querySelectorAll('p:not(:empty, .ia-module-container *), ol:not(.ia-module-container *), ul:not(.ia-module-container *)')].reduce((c, v) => {
				// Skip elements inside table cells (td or th)
				if (v.closest('td') || v.closest('th') || (v.parentNode && v.parentNode.nodeName.toLowerCase() === 'td')) {
					return c;
				}
				c.push(v);
				return c;
			}, []);

			const insert = sections.length > 1 ? sections[Math.ceil(sections.length / 2)] : sections[0];
			let insertP = null;

			if (insert.previousSibling) {
				insertP = insert.previousSibling;
				while (insertP && insertP.nodeName.toLowerCase() === 'p' && (!insertP.textContent)) {
					insertP = insertP.previousSibling;
				}
			}

			let insertNode = null;
			if (insertP && ['h1', 'h2', 'h3', 'h4', 'h5'].indexOf(insertP.nodeName.toLowerCase()) > -1) {
				insertNode = sections.length > 1 ? insertP : insert.nextSibling;
			} else {
				insertNode = sections.length > 1 ? insert : insert.nextSibling;
			}

			if (insertNode && insertNode.nodeName.toLowerCase() === 'ul') {
				if(insertNode.children.length > 3 && insertNode.parentNode.nodeName.toLowerCase() !== 'li' && elementToPlace.classList.contains('instreamAd-container')) {
					insertNode.insertBefore(elementToPlace, insertNode.children[3]);		
				} else {
				insert.parentNode.insertBefore(elementToPlace, insertNode.nextSibling);
				}
			} else {
				insert.parentNode.insertBefore(elementToPlace, insertNode);
			}

			if (mountable) {
				mountable.mount(elementToPlace);
			}
		},
		placeIcm(pn) {
			let elWrapper = document.querySelector('.active-page');

			if (!elWrapper) {
				elWrapper = document.querySelector(`.article-page[data-page="${pn || 1}"]`);
			}
			const sections = [...elWrapper.querySelectorAll('p:not(:empty), ol, ul, table')].reduce((c, v) => {
				if (v.parentNode && v.parentNode.nodeName.toLowerCase() === 'td') {
					return c;
				}
				c.push(v);
				return c;
			}, []);

			let insert = sections[sections.length - Math.floor(sections.length / 4) - 1];

			// Check if the insert element is inside a table
			while (insert && insert.closest('table')) {
				const index = sections.indexOf(insert);
				if (index > 0) {
					insert = sections[index - 1]; // Move to the previous section
				} else {
					insert = null; // No more valid sections
					break;
				}
			}

			const icmAd = document.querySelector('.ad-5000');

			// Check if both insert and insert.nextSibling are not inside a table
			if (icmAd && insert && (!window.s_publication_source || window.s_publication_source.indexOf('Healthwise') === -1)) {
				const nextSibling = insert.nextSibling;
				if (!insert.closest('table') && (!nextSibling || !nextSibling.closest('table'))) {
					insert.parentNode.insertBefore(icmAd, nextSibling);
				}
			}
		},
		load923Ad(adId) {
			const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
			window.webmd.adsConsumer.defineAd({
				id: adId,
				pos: '923',
				sizes: [1, 9],
				class: 'ad-923',
				targets: adTargets,
				blockCodes: this.store.pagedata.ad.blockCodes,
				keys: { strnativekey: 'Vjx59uEm8EVWkMyP8f8smvF8' },
			});
			window.webmd.adsConsumer.display();
		},
		loadInstreamAd(adObj) {
			if (window && window.webmd && window.webmd.adsConsumer) {
				window.webmd.adsConsumer.defineAd({
					id: adObj.id,
					class: 'ad-loaded',
					pos: adObj.pos,
					sizes: adObj.sizes,
					targets: adObj.targets,
				});
			}
		},
		parseEmbedModules(data) {
			let content = data;
			const embedModules = content.match(/<embeded_module.*<\/embeded_module>/gis);
			for (let i = 0; embedModules && i < embedModules.length; i += 1) {
				let embedChronicId = '';
				let embedType = '';
				const embedTag = embedModules[i].match(/<embeded_module.*?>/i);
				const matchedChronicId = embedTag[i].match(/_chronic_id="([^"]*)"/i);
				const matchedType = embedTag[i].match(/type=["|']?(\w*)["|']?/i);
				if (matchedChronicId && matchedChronicId.length > 0) {
					// eslint-disable-next-line
					embedChronicId = matchedChronicId[1];
					this.embedVideoId.push(matchedChronicId[1]);
				}
				if (matchedType && matchedType.length > 0) {
					// eslint-disable-next-line
					embedType = matchedType[1];
				}
				const unique = `embed-${new Date().getUTCMilliseconds()}`;

				const embedHtmlPlaceholder = `<div id="${unique}" data-embed-chronicle="${embedChronicId}"
					data-embed-type="${embedType}" data-embed-count="${i + 1}"></div>`;

				// if video and align=top, replace with video in-article
				this.showInArticleVideo = embedType.toLowerCase() === 'video' && embedTag[i].match(/\salign="top"/i) && this?.$route?.query?.vid === 'on';
				if (this.showInArticleVideo) {
					this.hasEmbeddedVideo = true;

					// replace the embed modules handled to remove from source
					content = content.replace(embedModules[i], embedHtmlPlaceholder);
				}
			}
			if (embedModules && this.showInArticleVideo) {
				this.parseVideoldJson(embedModules);
			}
			return content;
		},
		parseVideoldJson(embedModules) {
			const embedVdoName = embedModules[0].match(/<title>(.*?)<\/title>/i) || '';
			const embedVdoDescription = embedModules[0].match(/<wbmd_desc_meta>(.*?)<\/wbmd_desc_meta>/i) || '';
			const embedVdoDuration = this.getDuration(embedModules[0].match(/<wbmd_c_duration>(.*?)<\/wbmd_c_duration>/i)) || '';
			const embedVdoPubDate = embedModules[0].match(/<wbmd_orig_pub_dt>(.*?)<\/wbmd_orig_pub_dt>/i) || '';
			const embedVdoThumbnail = embedModules[0].match(/<image_path>(.*?)<\/image_path>/i) || '';
			const embedVdoContentUrl = embedModules[0].match(/<wbmd_c_loc_url>(.*?)<\/wbmd_c_loc_url>/i) || '';
			const regex = /<tt\sxml:lang="(.*?)"/i;
			const embedVdoinLanguage = embedModules[0].match(regex) || '';
			const transRegex = /<p\sbegin(.*?)>([^<]+)<\/p>/gi;
			const embedVdoTranscript = this.getTranscript(embedModules[0].match(transRegex)) || '';

			const embededVdoModules = {
				embedVdoName,
				embedVdoDescription,
				embedVdoDuration,
				embedVdoPubDate,
				embedVdoThumbnail,
				embedVdoContentUrl,
				embedVdoinLanguage,
				embedVdoTranscript,
			};
			this.updateJsonldVideo(embededVdoModules);
		},
		getTranscript(embedVdoTranscript) {
			if (!embedVdoTranscript) {
				return false;
			}
			let newTranscriptValue;
			if (embedVdoTranscript) {
				// eslint-disable-next-line no-plusplus
				for (let i = 0; i < embedVdoTranscript.length; i++) {
					newTranscriptValue += embedVdoTranscript[i].replace(/<\/?p[^>]*>/gi, '');
				}
				newTranscriptValue = newTranscriptValue.replace(/(\r\n|\n|\r)/gm, '');
				newTranscriptValue = newTranscriptValue.replace(/\s+/g, ' ').replace('undefined', '').trim();
			}

			return newTranscriptValue;
		},
		getDuration(timestamp) {
			let formatted = '';
			// eslint-disable-next-line no-restricted-globals
			if (timestamp && timestamp[1] && (!isNaN(timestamp[1]))) {
				formatted = 'PT';
				const hours = Math.floor(timestamp[1] / 60 / 60);
				if (hours > 0) {
					formatted += `${hours}H`;
				}
				const minutes = Math.floor(timestamp[1] / 60) - (hours * 60);
				if (minutes > 0) {
					formatted += `${minutes}M`;
				}
				const seconds = timestamp[1] % 60;
				if (seconds > 0) {
					formatted += `${seconds}S`;
				}
			}

			return formatted;
		},
		parseContent(isMobile) {
			let medrefContent = '';
			const artChronId = this.moduleByChronicId.module_settings.metadata_section.i_chronicle_id;
			if ((isMobile && this.medrefContentMobile) || (!isMobile && this.medrefContentDesktop)) {
				return null;
			}

			if (_has(this.medref, 'medrefData.medrefContent') && _has(this.medref, 'medrefData.medrefContent["#cdata-section"]')) {
				medrefContent = this.medref.medrefData.medrefContent['#cdata-section'];
				// eslint-disable-next-line no-useless-escape
				const selfClosedEmbededTags = '(<\s*embeded_module[^>]*)/\s*>';
				medrefContent = medrefContent.replace(new RegExp(selfClosedEmbededTags, 'gi'), '$1></embeded_module>');
				medrefContent = medrefContent.replace(/[\t\r\n]/g, '');

				const isEmbeddedArticle = medrefContent.match(/<embeded_module.*?>(.*?)<\/embeded_module>/gi);

				if (isEmbeddedArticle) {
					const embeddedData = this.getEmbededData(medrefContent, artChronId);
					if (embeddedData) {
						medrefContent = embeddedData.articleContent;
						this.embededModuleObject = embeddedData.embededModuleObject;
						this.videoThumbnailImage = embeddedData.videoThumbnail;
						this.embedImagePath = embeddedData.embedImagePath;
					}
				}

				if (!isMobile) {
					medrefContent = medrefContent.replace(/<pagebreak\s+type="mobile"\s*order="(\d+)"\s*\/>/gi, '');
				} else {
					medrefContent = medrefContent.replace(/<pagebreak\s+type="desktop"\s*order="(\d+)"\s*\/>/gi, '');
				}

				// eslint-disable-next-line
				const selfCloseStyleTags = medrefContent.match(/<style\s*([^\/>]+)\/>/gi);
				if (selfCloseStyleTags && selfCloseStyleTags.length > 0) {
					for (let i = 0; i < selfCloseStyleTags.length; i += 1) {
						const correctStyleTag = selfCloseStyleTags[i].replace(/\/>/gi, '></style>');
						medrefContent = medrefContent.replace(selfCloseStyleTags[i], correctStyleTag);
					}
				}

				// medrefContent = medrefContent.replace(/<style\s*([^\/>]+)\/>/gi, '');

				medrefContent = medrefContent.replace(/<section_group>(<pagebreak\s+type="[^>]+"\s*order="\d+"\s*\/>)/gi, '$1<section_group>');

				/*
				 * remove embed modules
				 * @todo check if this is needed for non-IA
				 */
				if (isMobile) {
					medrefContent = medrefContent.replace(/<embeded_module.*<\/embeded_module>/gi, '');
				}

				const imagesRegex = '<img[^>]+path=["|\']([^">]+)["|\']+' || '<img[^>]+order=["|\']([^">]+)["|\']+';

				const matchedImageTags = medrefContent.match(new RegExp(imagesRegex, 'gi'));

				if (matchedImageTags && matchedImageTags.length > 0) {
					for (let img = 0; img < matchedImageTags.length; img += 1) {
						const path = matchedImageTags[img].replace(/"/g, "'");
						const srcRegex = /<img.*?src='(.*?)'/;
						let src;

						if (path.match(new RegExp(imagesRegex))[1].includes('//')) {
							// eslint-disable-next-line prefer-destructuring
							src = path.match(new RegExp(srcRegex))[1];
						} else {
							src = `${this.imageServerUrl}${path.match(new RegExp(imagesRegex))[1]}`;
						}

						let cleanedpath = path.replace(/(data-[a-zA-Z0-9-]+|height|width|path)=["'](.*?)["']/g, '').replace(/<img([^>]+)\s*\/?/, (match, attributes) => `<img ${attributes.replace(/\s+/g, ' ').trim()}`);
						cleanedpath = cleanedpath.replace(/src=["'](.*?)["']/, `src='${src}'`);

						if (this.isImageCollection) {
							const resizePath = src + this.imgCollectionResize;
							cleanedpath = cleanedpath.replace(/src=["'](.*?)["']/, `src='${resizePath}'`);
							medrefContent = medrefContent.replace(matchedImageTags[img], cleanedpath);
						} else {
							medrefContent = medrefContent.replace(matchedImageTags[img], cleanedpath);
						}
					}
				}

				const m = medrefContent.match(/<section_header[^>]*>([^<]+)<\/section_header>/gi);

				if (m && m.length > 0) {
					const inArticleArray = [];

					for (let i = 0; i < m.length; i += 1) {
						const obj = {
							original: m[i],
							text: m[i].replace(/<\/?section_header[^>]*>/gi, ''),
						};

						const tmpArray = medrefContent.split(m[i]);

						if (tmpArray.length > 1) {
							const m2 = tmpArray[0].match(/<pagebreak type="mobile"/gi) || tmpArray[0].match(/<pagebreak type="desktop"/gi);

							if (m2) {
								obj.page = m2.length;
							} else {
								obj.page = tmpArray.length;
							}

							const m3 = tmpArray[0].match(/<section_group>/gi);

							if (m3) {
								obj.section = m3.length;
							}

							if (obj.page && obj.section) {
								obj.dataLink = `${obj.page}-${obj.section}`;
								obj.href = `#${artChronId}-${obj.page}-${obj.section}`;
							}
						}

						// excluding continued sections PPE-227238
						if (obj.original.indexOf('is_continued="true"') === -1) {
							inArticleArray.push(obj);
						}
						medrefContent = medrefContent.replace(new RegExp(`${obj.original.replace(/\?/gi, '\\?').replace(/\//gi, '\\/').replace(/\(/gi, '\\(').replace(/\)/gi, '\\)')}`, 'gi'), `<h2 class="jumplink-headers" id="${artChronId}-${obj.page}-${obj.section}">${obj.text}</h2>`);
					}

					if (!isMobile) {
						this.inThisArticle = inArticleArray;
					} else if ((this.isSiteFronts || this.isOncology) && isMobile) {
						this.inThisArticleMobile = inArticleArray;
					}
				}

				// TODO: this needs to be removed once video player is limited to running once
				const embedModules = medrefContent.match(/<embeded_module.*<\/embeded_module>/gis);
				if (embedModules) {
					if (!isMobile) {
						// handle embed modules
						medrefContent = this.parseEmbedModules(medrefContent);
					}
				}

				medrefContent = medrefContent.replace(/<section_group>/gi, '<section>').replace(/<\/section_group>/gi, '</section>');
				medrefContent = medrefContent.replace(/<section_text>/gi, '').replace(/<\/section_text>/gi, '');
				medrefContent = medrefContent.replace(/<section_text \/>/gi, '');
				medrefContent = medrefContent.replace(/<highlights \/>/g, '');
				medrefContent = medrefContent.replace(/<highlights>/gi, '').replace(/<\/highlights>/gi, '');
				medrefContent = medrefContent.replace(/<pull_quotes \/>/g, '');
				medrefContent = medrefContent.replace(/<pull_quotes>/gi, '').replace(/<\/pull_quotes>/gi, '');
				medrefContent = medrefContent.replace(/<section_header \/>/gi, '').replace(/<section_header><\/section_header>/gi, '').replace(/<section_header/gi, '<h2').replace(/<\/section_header>/gi, '</h2>');
				medrefContent = medrefContent.replace(/\/a><a /g, '/a> <a ');
				medrefContent = medrefContent.replace(/&gt;&lt;\/iframe&gt;/g, '></iframe>');
				medrefContent = medrefContent.replace(/&lt;iframe/g, '<iframe');
				medrefContent = medrefContent.replace(/<p \/>/gi, '');
				medrefContent = medrefContent.replace(/<i \/>/gi, '');
				medrefContent = medrefContent.replace(/<em \/>/gi, '');
				medrefContent = medrefContent.replace(/<u \/>/gi, '');

				// Fix text for Bold formatting
				const bTags = medrefContent.match(/<b \/>/g);
				if (bTags && bTags.length > 0) {
					medrefContent = medrefContent.replace(/<b \/>/g, '<b></b>');
				}

				const strongTags = medrefContent.match(/<strong \/>/g);
				if (strongTags && strongTags.length > 0) {
					medrefContent = medrefContent.replace(/<strong \/>/g, '<strong></strong>');
				}

				// Replace crossLinkType with data-crosslink-type
				const crossLinkTypePattern = '(crossLinkType=")([^"]*)';

				medrefContent = medrefContent.replace(new RegExp(crossLinkTypePattern, 'gi'), (_, __, second) => `data-crosslink-type="${second.toLowerCase()}`);

				// Add metrics to ICLT crosslinks
				const icltPattern = '(crosslinksource="ICLT")';
				medrefContent = medrefContent.replace(new RegExp(icltPattern, 'gi'), 'data-metrics-module="embd-lnkiclt"');

				// PPE-246531 replace link_friendlyurl for href
				const linkPattern = '(link_friendlyurl=")([^"]*)';

				medrefContent = medrefContent.replace(new RegExp(linkPattern, 'gi'), 'href="$2');

				// PPE-284999 hack to remove anchor tags for xml links
				medrefContent = medrefContent.replace(/(href=")([^"]*.xml")/gi, 'href="dummyxmlLinks"');
				// eslint-disable-next-line
				medrefContent = medrefContent.replace(/<a[^>]+href=\"(dummyxmlLinks)\"[^>]*>(.*?)<\/a>/gi, '$2');

				// remove anchor tags when href is empty
				medrefContent = medrefContent.replace(/<a[^>]+href=" *?"[^>]*>(.*?)< *\/a *>/gi, (a, b) => b);

				const isPageBreak = medrefContent.match(/<\s*pagebreak[^>]*>(.*?)/gi);
				let sArray;

				if (isPageBreak && isPageBreak.length > 0) {
					sArray = medrefContent.split(/<pagebreak\s+type="[^>]+"\s*order="\d+"\s*\/>/gi);

					if (isMobile) {
						this.totalPagesMobile = sArray.length - 1;
					} else {
						this.totalPagesDesktop = sArray.length - 1;
					}
					medrefContent = '';

					for (let i = 1; i < sArray.length; i += 1) {
						sArray[i] = sArray[i].replace(/<highlights>(.*)<\/highlights>/gi, '');

						const continueMatchs = [...Array.from(sArray[i].match(/<\s*h2[^>]*>(.*?)<\s*\/\s*h2>/gi) || []), ...Array.from(sArray[i].match(/<h2.*?>([\s\S]*?)<\/h2>/gi) || [])];

						// Removing section header with continued word
						if (continueMatchs && continueMatchs.length > 0) {
							for (let j = 0; j < continueMatchs.length; j += 1) {
								if (continueMatchs[j].includes('continued...')) {
									sArray[i] = sArray[i].replace(continueMatchs[j], ' ');
								}
							}
						}
						medrefContent += `<div class="article-page ${i === 1 ? 'active-page' : ''}" data-page="${i}">${sArray[i]}</div>`;
					}
				} else {
					sArray = medrefContent.split(/<section>(.*?)<\/section>/gi);
					if (isMobile) {
						this.totalPagesMobile = 1;
					} else {
						this.totalPagesDesktop = 1;
					}
					const test = [];
					medrefContent = '';
					for (let i = 0; i < sArray.length; i += 1) {
						if (sArray[i]) {
							sArray[i] = sArray[i].replace(/<p><p>/gi, '<p>');
							sArray[i] = sArray[i].replace(/<\/p><\/p>/gi, '</p>');
							sArray[i] = `<section>${sArray[i]}</section>`;
							test.push(sArray[i]);
						}
					}
					for (let i = 0; i < test.length; i += 1) {
						test[i] = test[i].replace(/<h2\s*id="undefined-.*?>/gi, `<h2 id="-${i + 1}">`);
					}
					medrefContent += `<div class="article-page active-page" data-page="1"><section_groups>${test.join('')}</section_groups></div>`;
				}
			}
			return medrefContent;
		},
		getFriendlyUrl() {
			const friendlyUrls = this.store.cms.friendlyURLData;
			let furl = '';

			// find appropriate site and return prefix and path
			if (friendlyUrls
				&& friendlyUrls.target
				&& friendlyUrls.target.siteid
				&& friendlyUrls.target.friendlyurl
				&& friendlyUrls.target.siteid === '3') {
				// set the protocol
				if (friendlyUrls.target.isHttps && friendlyUrls.target.isHttps.toLowerCase() !== 'true') {
					furl = 'http';
				} else {
					furl = 'https';
				}

				// set the subdomain
				if (friendlyUrls.target.prefix) {
					furl = furl.concat('://', friendlyUrls.target.prefix.toLowerCase());
				} else {
					furl = furl.concat('://', 'www');
				}

				/*
				 * set the TLD and path
				 * @TODO: set the lifecycle and environment
				 */
				return furl.concat('.webmd.com', friendlyUrls.target.friendlyurl.toLowerCase());
			}

			return furl;
		},
		addThreeStack(page, firstLast) {
			const pageNumber = page.dataset.page;
			const stId = `responsive_sharethrough_${this.infArticleNumber}_${pageNumber}_${1}`;
			const adDiv = document.createElement('div');
			const mnetDiv = document.createElement('div');
			const iaDiv = document.createElement('div');
			const mnetAdId = `mnet-ia-instream-${this.infArticleNumber}`;
			const infiniteAdId = `infinite-ad-${this.infArticleNumber}-${pageNumber}`;
			const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
			adTargets.pg = pageNumber;
			const frameProps = {
				first: firstLast,
				last: firstLast,
				margin: {
					top: 600,
					bottom: 0,
				},
				bypassRefresh: pageNumber > 1,
				ad: {
					pos: this.isInTabletRange ? 141 : 1923,
					sizes: this.isInTabletRange ? [[728, 90], [728, 92]] : [1, 9],
					id: stId,
					targets: { ...adTargets },
				},
			};
			const recProps = {
				margin: {
					top: 400,
					bottom: 100,
				},
			};
			const mnetProps = {
				ad: {
					id: mnetAdId,
					artNum: this.infArticleNumber,
				},
			};
			if (this.infArticleNumber === 1 && pageNumber === '1') {
				frameProps.margin.top = 4000;
			}

			if (this.infArticleNumber === 1) {
				recProps.margin.top = 2000;
			}

			page.appendChild(adDiv);
			createApp(iaAd, frameProps)
				.use(this.$pinia)
				.mount(adDiv);

			// Creating Containers and loading Recommended top picks module on page one
			if (this.isInfinite && pageNumber === '1' && !this.isBlogArticle) {
				const shareThroughAd1 = document.getElementById(stId);
				const infiniteAd1 = document.getElementById(infiniteAdId);
				// eslint-disable-next-line no-bitwise
				const recTpMod = `rec-tp-mod-${(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)}`;
				// eslint-disable-next-line no-bitwise
				const rectopEle = document.createElement('div');
				rectopEle.setAttribute('id', recTpMod);
				rectopEle.setAttribute('class', 'instream-feature-module-container');

				if (firstLast) {
					page.insertAdjacentElement('afterend', rectopEle);
				} else if (shareThroughAd1) {
					shareThroughAd1.insertAdjacentElement('beforebegin', rectopEle);
				} else if (infiniteAd1) {
					infiniteAd1.insertAdjacentElement('afterend', rectopEle);
				}

				createApp(instreamFeaturedModule, recProps)
					.use(this.$pinia)
					.use(metric)
					.mount(rectopEle);
			}

			if (this.isInfinite && pageNumber === '2' && !this.isBlogArticle) {
				const shareThroughAd = document.getElementById(stId);
				const infiniteAd = document.getElementById(infiniteAdId);
				const iaModProps = {
					articleNum: this.infArticleNumber,
					moduleId: 11,
				};

				const webmdIaDynamicMod = createApp(webmdIAModule, iaModProps)
					.use(this.$pinia);

				if (infiniteAd) {
					infiniteAd.insertAdjacentElement('beforebegin', iaDiv);
					webmdIaDynamicMod.mount(iaDiv);
				} else if (shareThroughAd) {
					shareThroughAd.insertAdjacentElement('beforebegin', iaDiv);
					webmdIaDynamicMod.mount(iaDiv);
				}

				const mediaNetAd = createApp(iaMediaNetLnk, mnetProps)
					.use(this.$pinia);

				if (shareThroughAd) {
					shareThroughAd.insertAdjacentElement('beforebegin', mnetDiv);
					mediaNetAd.mount(mnetDiv);
				} else if (infiniteAd) {
					infiniteAd.insertAdjacentElement('beforebegin', mnetDiv);
					mediaNetAd.mount(mnetDiv);
				}
			}

			if (this.isInfinite && pageNumber === '3' && !this.isBlogArticle) {
				const shareThroughAd1 = document.getElementById(stId);

				// Suggested questions module on non view port ads page
				if (shareThroughAd1) {
					// eslint-disable-next-line no-bitwise
					const recTpMod = `rec-tp-mod-${(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)}`;
					// eslint-disable-next-line no-bitwise
					const rectopEle = document.createElement('div');
					rectopEle.setAttribute('id', recTpMod);
					rectopEle.setAttribute('class', 'instream-feature-module-container');
					shareThroughAd1.insertAdjacentElement('beforebegin', rectopEle);
					createApp(instreamFeaturedModule, { QandAmodule: true })
						.use(this.$pinia)
						.use(metric)
						.mount(rectopEle);
				}
			}
		},
		setPublicationName() {
			const metaData = this.metadataModule;
			const pubName = metaData && _has(metaData, 'wbmd_publ.wbmd_publ_name')
				? metaData.wbmd_publ.wbmd_publ_name : '';

			if (pubName === 'WebMD Medical Reference Bundle') {
				this.isLegacyBundleArticle = true;
				this.hideInArticle = true;
			}
			if (pubName === 'WebMD Medical Reference Rare Diseases Bundle') {
				this.isLegacyBundleArticle = true;
			}
			if (pubName === 'WebMD Medical Reference Rare Diseases') {
				this.isRDGSingleArticle = true;
			}
			if (pubName === 'WebMD Image Collection') {
				this.isImageCollection = true;
				this.getImagecollectionData();
			}

			/* Code to display publication-top for news and feature cap Starts */

			const companyType = metaData && _has(metaData, 'wbmd_cpyrt.wbmd_copyright_holder.wbmd_comp_type.wbmd_disp_nm')
				? metaData.wbmd_cpyrt.wbmd_copyright_holder.wbmd_comp_type.wbmd_disp_nm : '';

			const blog = metaData && _has(metaData, 'wbmd_bus_ref.wbmd_storage_val')
				? metaData.wbmd_bus_ref.wbmd_storage_val : '';

			if ((pubName.toLowerCase().indexOf('interactive') === -1) && blog !== '73' && (companyType.toLowerCase().indexOf('content partner') === 0)) {
				this.publDisplay = metaData && _has(metaData, 'wbmd_publ.wbmd_publ_display')
					? metaData.wbmd_publ.wbmd_publ_display : '';

				this.publisherLogo.src = this.medref.medrefMetaData.publisherLogo.src;
				this.publisherLogo.alt = this.medref.medrefMetaData.publisherLogo.alt;
			}

			/* Code to display publication-top for news and feature cap Ends */

			/* Code to display subHeadLine for news and feature cap Starts */
			if (pubName !== 'WebMD Definition') {
				this.subHeadLine = this.medref && _has(this.medref, 'medrefData.subHeadLine')
					? this.medref.medrefData.subHeadLine : '';
			}

			/* Code to display subHeadLine for news and feature cap Ends */
		},
		showArchiveModal() {
			this.archive.modalVisible = true;

			setTimeout(() => {
				document.querySelector('.webmd-dialog__wrapper.archive-dialog').style.zIndex = 2000100;
				document.querySelector('.v-modal').style.zIndex = 2000010;
			}, 50);
		},
		getArchivePopup() {
			if (_has(this.store, 'cms.friendlyURLData.target.centers.Health.friendlyurl')) {
				this.archive.indexLink = this.store.cms.friendlyURLData.target.centers.Health.friendlyurl || '';
			}
			this.archive.indexLink = this.archive.indexLink.replace('default.htm', 'news-features');

			if (this.moduleByChronicId && _has(this.moduleByChronicId, 'module_settings.metadata_section.wbmd_archive_bool')
				&& this.moduleByChronicId.module_settings.metadata_section.wbmd_archive_bool === '1') {
				this.archive.showArchive = true;

				if (_has(this.moduleByChronicId, 'module_data.content_section.cons_news')) {
					this.archive.popupText = `<h3>This article is from the WebMD News Archive</h3>
						<p>This content has not been reviewed within the past year and may not represent WebMD's
						most up-to-date information.</p>`;
					if (_has(this.moduleByChronicId, 'module_settings.metadata_section.wbmd_c_channel_id.wbmd_disp_nm')) {
						// eslint-disable-next-line
						this.archive.linkText = `See the latest news and features on ${this.moduleByChronicId.module_settings.metadata_section.wbmd_c_channel_id.wbmd_disp_nm}`;
					}
				} else if (_has(this.moduleByChronicId, 'module_data.content_section.cons_feature')) {
					this.archive.popupText = `<h3>This article is from the WebMD Feature Archive</h3>
						<p>WebMD archives content after 2 years to ensure our readers can easily
						find the most timely content.</p>`;
					if (_has(this.moduleByChronicId, 'module_settings.metadata_section.wbmd_c_channel_id.wbmd_disp_nm')) {
						// eslint-disable-next-line
						this.archive.linkText = `See the latest news and features on ${this.moduleByChronicId.module_settings.metadata_section.wbmd_c_channel_id.wbmd_disp_nm}`;
					}
				}
			}
		},

		/**
		 * getImagecollectionData
		 * This method is to get the image collcetion data from store
		 */
		getImagecollectionData() {
			const module = this.moduleByChronicId;
			const key = `${this.medref.medrefData.contentSectionType}.related_links_text.p.a`;
			const imageLinksdata = _get(module, key);

			if (imageLinksdata) {
				if (module && _has(module, key) && _isArray(imageLinksdata)) {
					this.previousLink = imageLinksdata[0].link_friendlyurl ? imageLinksdata[0].link_friendlyurl : '';
					this.nextLink = imageLinksdata[1].link_friendlyurl ? imageLinksdata[1].link_friendlyurl : '';
					this.relatedLinksdata = imageLinksdata.map((obj) => _pick(obj, ['link_friendlyurl']));
				} else if (module && _has(module, key) && _isObject(imageLinksdata)) {
					if (imageLinksdata.img.alt === 'back button') {
						this.previousLink = imageLinksdata.link_friendlyurl ? imageLinksdata.link_friendlyurl : '';
					} else {
						this.nextLink = imageLinksdata.link_friendlyurl ? imageLinksdata.link_friendlyurl : '';
					}
					this.relatedLinksdata = _pick(imageLinksdata, ['link_friendlyurl', 'img.alt']);
				}
			}
		},

		/**
		 * getImagecollection
		 * This method is to create HTML DOM for image collection componenet
		 */
		getImagecollection() {
			const articleParent = document.querySelector('.article.medref.image-collection .article__body .article-page');
			if (articleParent) {
				let nextSiblingText = '';
				const imageContainer = articleParent.children[0];
				const imageFooter = articleParent.children[1];
				const imageDescription = articleParent.children[2];
				imageDescription.className = 'image-description';
				const collectionNavigation = document.createElement('figcaption');
				collectionNavigation.className = 'article-image_collection_nav';
				const figcaptionHTML = `
					<ul class='related-images'>
						<li>
							<a href="${this.previousLink}">
								Prev
							</a>
						</li>
						<li>
							<a href="${this.nextLink}">
								Next
							</a>
						</li>
					</ul>
				`;
				document.querySelectorAll('section > h2').forEach((el) => {
					if ((el.innerText.toLowerCase().indexOf('image source')) === 0) {
						nextSiblingText = el.nextSibling.innerText;
						el.remove();
						imageFooter.children[0].remove();
					}
				});
				if (nextSiblingText) {
					collectionNavigation.innerHTML = `${nextSiblingText}${figcaptionHTML}`;
				} else {
					collectionNavigation.innerHTML = `${figcaptionHTML}`;
				}
				imageContainer.innerHTML = imageContainer.innerHTML.replace(/<img/g, '<figure><img');
				imageContainer.querySelector('figure').appendChild(collectionNavigation);
				/* eslint-disable no-param-reassign */
				articleParent.innerHTML = articleParent.innerHTML.replace(/<section><\/section>/gi, '');
				articleParent.innerHTML = articleParent.innerHTML.replace(/<p><\/p>/gi, '');
				articleParent.innerHTML = articleParent.innerHTML.replace(/<br><\/span>/g, ' </span>');
				/* eslint-enable no-param-reassign */
			}
		},
		preloadEmbedAssetsImage() {
			if (this.videoThumbnailImage) {
				// preloading first embeded video module poster image
				this.store.cms.appendPreLoadData({ url: this.videoThumbnailImage, type: 'image' });
			} else if (this.embedImagePath) {
				// preloading first embeded image module imagepath
				this.store.cms.appendPreLoadData({ url: this.embedImagePath, type: 'image' });
			} else if (this.jsonldVideo.thumbnailUrl) {
				// preloading in-article video poster image
				const posterImg = this.jsonldVideo.thumbnailUrl + this.desktopVideoPosterResize;
				this.store.cms.appendPreLoadData({ url: posterImg, type: 'image' });
			}
		},
		preloadHeroImage() {
			const medrefContent = _has(this.medref, 'medrefData.medrefContent["#cdata-section"]') ? this.medref.medrefData.medrefContent['#cdata-section'] : null;
			if (!medrefContent) { return; }
			const imagesRegex = '<img[^>]+path=["|\']([^">]+)["|\']+';
			const heroRegex = '<img[^>]+order=["|\'](hero)["|\']+';
			const heroImageTags = medrefContent.match(new RegExp(heroRegex, 'gi'));

			if (heroImageTags && heroImageTags[0]) {
				let imageUrl = `${this.imageServerUrl}${heroImageTags[0].match(new RegExp(imagesRegex))[1]}`;
				if (imageUrl) {
					this.articleHeroImage = imageUrl;
					if (this.isImageCollection) {
						imageUrl += this.imgCollectionResize;
					} else {
						imageUrl += this.heroImgResize.mobile;
					}
					this.store.cms.appendPreLoadData({ url: imageUrl, type: 'image' });
				}
			}
		},

		moveSFInArticleNav() {
			const nextArticle = document.getElementsByClassName('module-next-article');
			const articleNav = document.getElementsByClassName('sf-in-article-nav cb-nav');
			// eslint-disable-next-line max-len
			if (nextArticle && nextArticle[0] && nextArticle[0].parentElement && articleNav && articleNav[0]) {
				nextArticle[0].parentElement.appendChild(document.getElementsByClassName('sf-in-article-nav cb-nav')[0]);
			}
		},
		toggle(which) {
			if (which === this.show) {
				this.show = false;
			} else {
				this.show = which;
			}
		},
		updateJumplinkIds() {
			const artNum = this.infArticleNumber ? this.infArticleNumber : 1;
			if (artNum && artNum > 0) {
				window.setTimeout(() => {
					const artBody = [...document.querySelectorAll('article')][artNum - 1];
					const navSelector = (this.isMobile || this.isNewTabSpec) ? '.oncology-article-nav .nav-menu li a' : '.oncology-article-nav .nav-items li a';
					const navListitems = [...artBody.querySelectorAll(navSelector)];
					const jumplinkHeaders = [...artBody.getElementsByClassName('jumplink-headers')];
					if (navListitems && navListitems.length && jumplinkHeaders && jumplinkHeaders.length) {
						navListitems.forEach((e1, index) => jumplinkHeaders.forEach((e2) => {
							// eslint-disable-next-line max-len
							if ((e1?.innerHTML && e2?.innerHTML) && (e1.innerHTML.trim().toLowerCase() === e2.innerHTML.trim().toLowerCase())) {
								/* eslint-disable no-param-reassign */
								e1.attributes.href.value = `#${artNum}-${index + 1}`;
								e2.attributes.id.value = `${artNum}-${index + 1}`;
								/* eslint-disable no-param-reassign */
								if(e2.getBoundingClientRect().top + window.pageYOffset < 1100) {
									e2.style.scrollMarginTop = '150px';
								}
							}
						}));
					}
				}, 500);
			}
		},
		createRelatedModule(pageSel, pageNum) {
			const relatedModuleParent = document.querySelector(pageSel);
			const instreamRelatedMod = `instream-related-mod-${this.pageNum}`;
			// eslint-disable-next-line no-bitwise
			const instreamRelatedEle = document.createElement('div');
			instreamRelatedEle.setAttribute('id', instreamRelatedMod);
			instreamRelatedEle.setAttribute('class', 'instream-related-mod');
			if (relatedModuleParent) {
				relatedModuleParent.insertAdjacentElement('afterbegin', instreamRelatedEle);
				const relatedModule = document.querySelector(`${pageSel} .instream-related-mod`);
				const relatedModProps = {
					relMmodule: 'rlt-inwell',
					relMlink: pageNum - 1,
				};
				createApp(instreamRelatedModule, relatedModProps)
					.use(this.$pinia)
					.use(metric)
					.mount(relatedModule);
			}
		},
		initViewportAds(artLength, lastPageNum) {
			const self = this;
			if (artLength && artLength === 1) {
				[...self.$el.querySelectorAll('.article-page')].forEach((el) => {
					if (!(el.querySelector('.instreamAd'))) {
						const adEl = document.createElement('div');
						const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
						const articleLength = this.infArticleNumber;
						adTargets.pg = el.dataset.page;
						adTargets.ll = 1;

						/*
						 * server side logic of first ad.
						 * if (adTargets.pg === '1-1') {
						 * 	const firstAd = document.getElementById('infinite-ad-1-1');
						 * 	if (!(firstAd && firstAd.classList.value.includes('instreamAd'))) {
						 * 		firstAd.classList.add('instreamAd');
						 * 	}
						 * }
						 */
						const adId = `infinite-ad-${articleLength}-${el.dataset.page || lastPageNum}`;
						const instreamAd = createApp(iaAd, {
							first: el.dataset.page === '1',
							last: el.dataset.page === lastPageNum,
							margin: {
								top: el.dataset.page === '1' && this.infArticleNumber > 1 ? 0 : 1000,
								bottom: 0,
							},
							ad: {
								pos: this.isInTabletRange ? 141 : 2026,
								sizes: this.isInTabletRange ? [[728, 90], [728, 92]] : [[300, 50], [300, 51], [300, 250], [300, 253],
									[320, 50], [320, 51], [320, 250]],
								id: adId,
								targets: { ...adTargets },
							},
						}).use(this.$pinia);

						// add 2026 ad in the middle of the page
						if (el.dataset.page === '1') {
							// instreamAd.mount(adEl); // server side first ad
							self.placeOutOfViewport(el, adEl, instreamAd);
							self.placeViewportAd(1);
							if (!self.isBlogArticle) {
								self.recommendedModule(2);
							}
						}

						// Suggested questions module before the 6th ad on viewport ads page
						if (!self.isBlogArticle) {
							self.recommendedModule(6, true);
						}
					}
				});
			} else if (artLength && artLength > 1) {
				self.placeViewportAd(0);
				if (!self.isBlogArticle) {
					self.recommendedModule(2);

					// Suggested questions module before the 6th ad on viewport ads page
					self.recommendedModule(6, true);
				}
			}
		},
		initNonViewportAds(artLength, lastPageNum) {
			const self = this;
			[...self.$el.querySelectorAll('.article-page')].forEach((el) => {
				if (!(el.querySelector('.instreamAd'))) {
					const pageNumber = el.dataset.page;
					const adEl = document.createElement('div');
					adEl.classList.add('instreamAd-container');
					const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
					adTargets.pg = pageNumber;
					adTargets.ll = 1;
					const adId = `infinite-ad-${this.infArticleNumber}-${pageNumber || lastPageNum}`;
					const instreamAd = createApp(iaAd, {
						first: pageNumber === '1',
						last: pageNumber === lastPageNum,
						margin: {
							top: pageNumber === '1' && window.infiniteList && Object.keys(window.infiniteList).length > 1 ? 0 : 600,
							bottom: 0,
						},
						bypassRefresh: pageNumber > 1,
						ad: {
							pos: this.isInTabletRange ? 141 : 2026,
							sizes: this.isInTabletRange ? [[728, 90], [728, 92]] : [[300, 50], [300, 51], [300, 250], [300, 253],
								[320, 50], [320, 51], [320, 250]],
							id: adId,
							targets: { ...adTargets },
						},
					}).use(this.$pinia);

					// If the last page...
					if (el.dataset.page === lastPageNum) {
						// ...of a one page article, add 1923 at the end
						if (lastPageNum === '1' && !this.isInteractivePage && !this.fedConfig) {
							self.addThreeStack(el, true);

							// ...of a multi-page article, add 2026 at the end
						} else {
							el.appendChild(adEl);
							instreamAd.mount(adEl);
							if (this.aiTestFlag) {
								self.moveAiModules();
							}
						}

						// add 2026 ad in the middle of the page
					} else if (el.dataset.page > 0
						|| (window.infiniteList && Object.keys(window.infiniteList).length > 1)) {
						if (self.isInteractivePage) {
							el.appendChild(adEl);
							instreamAd.mount(adEl);
						} else if (self.isInfinite && window.infiniteList && Object.keys(window.infiniteList).length === 1 && el.dataset.page === '1') {
							self.placeOutOfViewport(el, adEl, instreamAd);
						} else {
							self.placeElementInMiddle(el, adEl, instreamAd);
						}
					}

					// Insert stack ad at the end of each virtual page, if it's not the last page.
					if (el.dataset.page !== lastPageNum && !this.isInteractivePage && !this.fedConfig) {
						self.addThreeStack(el, false);
					}
				}
			});
		},
		getLastAdCount() {
			const adsList = Object.keys(window.webmd.ads.ads).filter((item) => item.includes('infinite-ad'));
			const adName = adsList[adsList.length - 1];
			let adCount = adName.split('-');
			adCount = adCount[adCount.length - 1];
			return adCount;
		},

		isTurnOffInfinite() {
			const suppressInfinite = this.metadataModule?.wbmd_suppress_infinite === '1';
			return suppressInfinite;
		},
		getNextAssetByWeight(assets) {
			const random = Math.floor(Math.random() * 100) + 1;
			if (!assets.length) {
				return assets;
			}
			const asset = assets.find((asset) => {
				if (!asset.weight) return false;
				return random >= asset.weight.from && random <= asset.weight.to;
			});
			return asset;
		},
		moveAiModules() {
			const self = this;
			const placeholderId = this.metadataModule.i_chronicle_id;
			const artSelector = document.querySelector(`[data-artid="${placeholderId}"]`);
			const ads = artSelector.querySelectorAll('[id^="infinite-ad-"]');
			const lastAd = ads[ads.length - 1].attributes.id.value;
			const targetElement = document.getElementById(lastAd);
			const aiModElement = artSelector.querySelector('.ai-modules');
			if (aiModElement) {
				targetElement.parentNode.insertBefore(aiModElement, targetElement);
			} else {
				// Elements are not present, wait for 500ms and try again
				if (self.attemptCount < 20) {
					setTimeout(() => {
						self.attemptCount += 1;
						self.moveAiModules();
					}, 500);
				}
			}
		},
		checkIfAdIsAvailable() {
			const self = this;
			// Determine which ad to check based on viewport
			const adToCheck = window.viewportFlag ? 'responsive_sharethrough_1_1_1' : 'infinite-ad-1-1';
			
			// Check if the ad is available
			if (adToCheck in window.webmd.ads.ads) {
				// Refresh existing ads
				window.webmd.ads.refresh();
				
				// Helper function to load an ad with specific ID and pg value
				const loadAd = (adId, pgValue) => {
					if (!(window.webmd.ads.ads[adId])) {
						// Create a fresh copy of ad targets for each ad
						const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
						adTargets.pg = pgValue;
						
						// Configure the ad
						const ad = {
							pos: this.isInTabletRange ? 141 : 2026,
							sizes: this.isInTabletRange ? [[728, 90], [728, 92]] : [[300, 50], [300, 51], [300, 250], [300, 253],
								[320, 50], [320, 51], [320, 250]],
							id: adId,
							targets: adTargets
						};
						window.webmd.ads.setPageTarget('pg', pgValue);
						// Load and refresh the ad
						this.loadInstreamAd(ad);
						window.webmd.ads.refresh({id: adId});
					}
				};
				if (!window.viewportFlag) {
					// Load second ad with pg=2 after 3 seconds
					setTimeout(() => {
						loadAd('infinite-ad-1-2', '2');
						// Load third ad with pg=3 after another 3 seconds (sequential loading)
						setTimeout(() => {
							loadAd('infinite-ad-1-3', '3');
						}, 1000);
					}, 1000);
				}
			} else if (self.adCheckCount < 100) {
				// If ad not available yet, retry after delay (up to 100 times)
				setTimeout(() => {
					self.adCheckCount += 1;
					self.checkIfAdIsAvailable();
				}, 300);
			}
		},
		
		loadNonViewportAds(pageNum, direction) {
			const self = this;
			const currentArtId = Object.keys(window.infiniteList)[this.infArticleNumber-1];
			const adTarget = this.store?.pagedata?.ad?.targets || window.infiniteList[currentArtId]?.ad?.targets;
			const adTargets = JSON.parse(JSON.stringify(adTarget));
			adTargets.pg = pageNum;
			const stId = `responsive_sharethrough_${this.infArticleNumber}_${pageNum}_${1}`;
			const adId = `infinite-ad-${this.infArticleNumber}-${pageNum}`;
			const lastPageNum = self.$el.querySelector('.article-page:last-child').dataset.page;
			const adsObj = {};
			const ad1923 = {
				pos: this.isInTabletRange ? 141 : 1923, sizes: this.isInTabletRange ? [[728, 90], [728, 92]] : [1, 9], id: stId, targets: { ...adTargets },
			};
			const ad2026 = {
				pos: this.isInTabletRange ? 141 : 2026,
				sizes: this.isInTabletRange ? [[728, 90], [728, 92]] : [[300, 50], [300, 51], [300, 250], [300, 253],
					[320, 50], [320, 51], [320, 250]],
				id: adId,
				targets: { ...adTargets },
			};
			const ad2025 = {
				pos: this.isInTabletRange ? 101 : 2025, sizes: this.isInTabletRange ? [] : [[300, 50], [320, 50]], id: this.isInTabletRange ? 'ad-pos-101-1' : 'ad-pos-2025-1', targets: { ...adTargets },
			};
			if (!(window.webmd.ads.ads[ad2026.id] || window.webmd.ads.ads[ad1923.id])) {
			    if (!(window.webmd.ads.ads[ad2026.id])) {
					this.loadInstreamAd(ad2026);
				}
				if (pageNum !== lastPageNum) {
					if (!(window.webmd.ads.ads[ad1923.id])) {
			        	this.loadInstreamAd(ad1923);
					}
					adsObj[stId] = true;
				}

			    // this.loadInstreamAd(ad2025);
			    adsObj[adId] = true;
			    adsObj[ad2025.id] = true;
				this.checkAndRefreshAds(adsObj, direction, pageNum)
			} else {
				if (pageNum !== lastPageNum) {
					if (!(window.webmd.ads.ads[ad1923.id])) {
			        	this.loadInstreamAd(ad1923);
					}
					adsObj[stId] = true;
				}
			    adsObj[adId] = true;
			    adsObj[ad2025.id] = true;
			    this.checkAndRefreshAds(adsObj, direction, pageNum)
			}
		},
		destroySlots(excludePos) {
			const destroy = [];
			const excluded = excludePos || [];

			// DO not destroy if window variables are not defined or if the page is not infinite
			if (!window.webmd || !window.webmd.ads || !this.isInfinite) {
				return;
			}

			if (window.s_business_reference.includes('slide show')) {
				excluded.push(2025, 121, 101, 113);
			}

			Object.keys(window.webmd.ads.ads).forEach((ad) => {
				const thisAd = window.webmd.ads.ads[ad];

				if (!excluded.includes(parseInt(thisAd.pos, 10))) {
					destroy.push(ad);
				}
			});

			window.webmd.ads.destroy(destroy);
		},
		checkAndRefreshAds(adsObj, direction, pageNum) {
			const adIds = Object.keys(adsObj);
			const allAdsExist = adIds.every(adId => window.webmd.ads.ads[adId]);
			if (allAdsExist) {
				if (direction && pageNum) {
					window.webmd.ads.setPageTarget('pg', `${pageNum + direction}`);
				} else {
					window.webmd.ads.setPageTarget('pg', pageNum);
				}
				window.webmd.ads.refresh({ id: adsObj });
			} else {
				setTimeout(() => this.checkAndRefreshAds(adsObj, direction, pageNum), 300);
			}
		}
	},
	created() {
		this.store = useStore(this.$pinia);
		this.imageServerUrl = this.getImageServerUrl();
		this.moduleByChronicId = this.getModuleByChronicId;
		this.medref = this.getItems;
		this.moduleData = this.getItems;
		this.metadataModule = this.getMetaData;
		this.turnOffInfinite = this.isTurnOffInfinite();
		this.medref.medrefMetaData = this.getMetaDataDetail;
		const nextArticleData = this.getNextAsset;
		if (nextArticleData && nextArticleData instanceof Array) {
			this.nextArticle = this.getNextAssetByWeight(nextArticleData);
		} else {
			this.nextArticle = nextArticleData;
		}
		this.iaSource = this.getNextAssetSource;
		this.isBundleArticle = this.store.flow.isBundle || false;
		this.setPublicationName();
		this.medrefContentDesktop = this.parseContent(false);
		this.medrefContentMobile = this.parseContent(true);
		this.updateJsonldData(this.medref.medrefMetaData, this.medref.medrefData.thumbnailImage);
		this.preloadEmbedAssetsImage();
		this.preloadHeroImage();
		if (this.isSiteFronts) {
			if (this.isLegacyBundleArticle) {
				this.seriesLabel = this.getSeriesLabel;
			}
		}
		this.localLang = this.store?.pagedata?.omniture?.s_language_locale;

		this.ecdQuery = this.$route?.query?.ecd || '';
		this.store.cms.updateRootClasses(['class-bg-ghost', 'webmd-onc-article']);
		this.categories = this.getCategories;
	},
	mounted() {
		const self = this;
		this.clientWidth = document.body.clientWidth;
		this.clientHeight = document.body.clientHeight;
		const busRef = this.store?.pagedata?.omniture?.s_business_reference?.toLowerCase();
		this.isMobile = (ua.type === 'mobile') && Math.min(this.clientWidth, this.clientHeight) < 467;
		const userAgent = navigator.userAgent.toLowerCase();
		this.isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

		// viewport logic to exclude few centers
		const vpTopics = ['1827', '1667', '1663', '3558', '1688', '3645', '3557', '1629', '4223', '3963', '1662', '3992', '1624', '3641', '1835', '3633', '1822', '4054', '1834', '2729', '1633', '1826', '1626', '3570', '3629', '3630'];

		const topicId = this.store?.pagedata?.omniture?.s_topic;
		const capId = this.store?.pagedata?.omniture?.s_cap_id;
		const isRdg = ['091e9c5e820e4e1e', '091e9c5e820e55b3'].includes(capId);
        // declare a variable to check if its loading first time.
		if (typeof window.firstTimeLoaded === 'undefined') {
            window.firstTimeLoaded = true;
		}
		window.viewportFlag = (topicId && vpTopics.includes(topicId));
		if (isRdg) {
			window.viewportFlag = false;
		}
		this.viewportFlag = !(window.viewportFlag);

		// ai test channels
		const AITestChannels = ['1020', '1123', '1060', '1136'];
		const channelId = this.store?.pagedata?.omniture?.center_id;
		const checkChannelExists = channelId && AITestChannels.includes(channelId);
		this.aiTestFlag = this.clientWidth < 1025 && checkChannelExists && this.isInfinite && (busRef === 'medical reference' || busRef === 'feature');
		this.aiTestNextArt = this.isMobile && checkChannelExists && this.isInfinite && (busRef === 'medical reference' || busRef === 'feature') && (this.categories?.length > 0);
		this.prSrchmodDsktp = this.clientWidth  > 1024 && checkChannelExists && (busRef === 'medical reference' || busRef === 'feature');
		
		if (this.infArticleNumber && this.infArticleNumber > 1) {
			const lastAd = this.getLastAdCount();
			window.adCounter = parseInt(lastAd, 10);
		}
		this.isEmbdAdFits = this.clientWidth < 1121 && this.clientWidth > 767;

		// new designs for tablet
		this.isInTabletRange = this.clientWidth > 767 && this.clientWidth < 1025;
		this.isNewTabSpec = this.isInTabletRange && !this.ecdQuery.includes('conmkt');
		if (this.isNewTabSpec) {
			window.ads_ignore = {
				...window.ads_ignore,
				121: true,
				137: true,
			};
		}

		if (this.isInTabletRange && this.ecdQuery.includes('conmkt')) {
			document.documentElement.classList.add('conmkt');
		}

		if (this.$route && this.$route.query && this.$route.query.qap) {
			this.qap = true;
			document.body.classList.add('webmd-qap-article');
		}

		// disable the ads call for initial load
		window.webmd.ads.disableInitialLoad();

		if (this.isSiteFronts && (this.isMobile || this.isNewTabSpec)) {
			this.inThisArticle = this.inThisArticleMobile;
		}

		if (this.siteFronts && window && window.is_embedded_module_top_aligned === 'false') {
			document.querySelector('.sf-article-hero').style.display = 'none';
		}

		if (this.isNewTabSpec) {
			this.viewAll();
			this.inThisArticle = this.inThisArticleMobile;
		}

		if (!this.isMobile && !this.isNewTabSpec) {
			this.rrAdsNew(isRdg);
			this.viewAll();
			window.addEventListener('scroll', this.handleScroll, { passive: true });
		}

		if (this.viewAllContent && this.clientWidth > 1024) {
			this.unpaginatedArticleLoader.then((comp) => {
				createApp(comp)
					.mount('#unpaginated-article');

				this.viewAll();
				window.addEventListener('scroll', this.handleScroll, { passive: true });
				if (window.rrAdsNew) {
					const singlePageArticle = document.querySelectorAll('.article-page')?.length === 1 ?? false;
					if (!singlePageArticle) {
						this.updatefirstPage137Ad();
					}
				}
			});
		} else {
			this.store.cms.UPDATE_STATE({ key: 'unPaginate', value: false });
		}

		if (document.getElementsByClassName('copyright').length) {
			this.isWebMDcopyright = true;
		}

		if (this.isMobile || this.isNewTabSpec) {
			if (!window.initialLoad) {
				if ('scrollRestoration' in window.history) {
					window.history.scrollRestoration = 'manual';
				}
				window.scrollTo(0, 0);
			}

			const { articleBody } = this.$refs;
			if (articleBody.innerHTML !== this.medrefContentMobile) {
				articleBody.innerHTML = this.medrefContentMobile;
			}

			// Destroy 2025 ad on Infinite FED article
			if (this.fedConfig && this.isInfinite) {
				self.destroyAd('ad-pos-2025-1');
			}

			// do not define 113 and 121 on mobile
			window.ads_ignore = window.ads_ignore || {};
			window.ads_ignore['113'] = true;

			// Set infiniteList
			window.infiniteList = window.infiniteList || {};
			// eslint-disable-next-line max-len
			window.infiniteList[this.metadataModule.i_chronicle_id] = JSON.parse(JSON.stringify(this.store.pagedata));

			if (Object.keys(window.infiniteList).length === 1 && (this.isMobile || this.isNewTabSpec) && !this.turnOffInfinite) {
				document.addEventListener('onAdobeOmniBeforePv', () => {
					const omniVal = `inf-${self.artNum}-${self.iaSource}`;
					if (window && window.adobeDataLayer) {
						window.adobeDataLayer.push({ page: { ia: omniVal } });
					} else {
						window.s_md.contextData['wb.ia'] = omniVal;
					}
				}, { once: true });
			}

			this.artNum = Object.keys(window.infiniteList).length;

			const lastPageNum = self.$el.querySelector('.article-page:last-child').dataset.page;
			const iaTimeout = window.iaTimeout || 3500;

			this.isSourceNews = this.store.pagedata.omniture.s_business_reference.toLowerCase() === 'news' && this.artNum === 1;

			if (!this.turnOffInfinite) {
				if (!this.isFlowingFromNews) {
					if (lastPageNum === '1') {
						// Load next article
						if (self.nextArticle && !self.qap) {
							setTimeout(() => {
								self.loadNextArticle(self.nextArticle);
							}, iaTimeout);
						} else if (!self.qap) {
							setTimeout(() => {
								self.getNextAssetRec().then((res) => {
									self.loadNextArticle(res);
								});
							}, iaTimeout);
						}
					}
				}
			}

			const artLength = this.infArticleNumber ? this.infArticleNumber : 1;
			if (!window.viewportFlag) {
				this.initViewportAds(artLength, lastPageNum);
			} else {
				this.initNonViewportAds(artLength, lastPageNum);
			}

			const intersectionObserver = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					intersectionObserver.unobserve(entries[0].target);

					// @todo fix pg
					const newId = `infinite-ad-${this.infArticleNumber}-${entries[0].target.dataset.page || lastPageNum}`;

					if (document.getElementById(newId)) {
						return;
					}

					const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
					const pageNum = entries[0].target.dataset.page;
					adTargets.pg = pageNum;
					adTargets.ll = 1;

					/*
					 * If the article doesn't have a next asset, fill the right ad replacement
					 * Otherwise, we use this slot for future articles and fill it later
					 */
					const ad2026Wrapper = document.getElementById('ads2-pos-2026-ad-right-replacement_1');
					if (!self.nextArticle && ad2026Wrapper !== null && ad2026Wrapper.innerHTML === '') {
						if (window.googletag && window.googletag.apiReady) {
							// force a new correlation id
							window.googletag.pubads().updateCorrelator();
						}

						window.webmd.adsConsumer.defineAd({
							id: 'ads2-pos-2026-ad-right-replacement_1',
							pos: '2026',
							sizes: [[300, 50], [300, 51], [300, 250],
								[300, 253], [320, 50], [320, 51], [320, 250]],
							targets: adTargets,
						});
					}
				}
			});

			/*
			 * this is to prevent multiple metrics calls
			 * in cases where the component is mounted multiple times
			 */
			if (!(window.metricsGathered)) {
				window.metricsGathered = [];
			}
			const metricsObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const pageNum = entry.target.dataset.page;
						if (entry.intersectionRect.top === 0) {
							self.$vwmddpv({
								moduleName: 'pg-n-swipe-up',
								iCount: pageNum,
								refresh: false,
							}, this.turnOffInfinite ? {} : {
								metrics: {
									'wb.ia': `inf-${self.artNum}-${self.iaSource}`,
								},
							});
							if (window.viewportFlag) {
								this.loadNonViewportAds(pageNum, 'u');
							}
						} else {
							self.$vwmddpv({
								moduleName: 'pg-n-swipe',
								iCount: pageNum,
								refresh: false,
							}, this.turnOffInfinite ? {} : {
								metrics: {
									'wb.ia': `inf-${self.artNum}-${self.iaSource}`,
								},
							});
							if (window.viewportFlag) {
								this.loadNonViewportAds(pageNum, '');
							}
						}

						
						if (window.metricsGathered.indexOf(`${this.infArticleNumber}-${pageNum}`) === -1) {
							window.metricsGathered.push(`${this.infArticleNumber}-${pageNum}`);

							// On the last page of the article, load the next one, if it exists or recommendation
							if (!this.turnOffInfinite) {
								if (!this.isFlowingFromNews) {
									if (pageNum === lastPageNum) {
										if (self.nextArticle && !self.qap) {
											self.loadNextArticle(self.nextArticle);
										} else if (!self.qap) {
											self.getNextAssetRec().then((res) => {
												self.loadNextArticle(res);
											});
										}
									}
								}
							}
						}
					}
				});
			});

			const metricsObserverFirstPage = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					const pageNum = entries[0].target.dataset.page;
					if (entries[0].intersectionRect.top === 0) {
						self.$vwmddpv({
							moduleName: 'pg-n-swipe-up',
							iCount: pageNum,
							refresh: false,
						}, this.turnOffInfinite ? {} : {
							metrics: {
								'wb.ia': `inf-${self.artNum}-${self.iaSource}`,
							},
						});
						if (self.artNum === 1 && window.viewportFlag) {
						    this.loadNonViewportAds(pageNum, 'u');
						}
					} else if (self.artNum > 1 && window.viewportFlag) {
						const posVal = this.clientWidth > 767 ? 101 : 2025;
						this.destroySlots([posVal]);
						    this.loadNonViewportAds(pageNum, '');
					}
				}
			});

			[...self.$el.querySelectorAll('.article-page:not([data-page="1"]), footer, #ContentPane41')].forEach((el) => {
				if (el.dataset.page !== lastPageNum) {
					/*
					 * Start loading ads after 20px of the article in the view.
					 * This also gives metrics time to set a new PVID to match
					 */
					intersectionObserver.observe(el, { rootMargin: '-15px' });
				} else if (el.nodeName.toLowerCase() === 'footer' || el.id === 'ContentPane41') {
					// Load the ad when the container is 50px from coming into view
					intersectionObserver.observe(el, { rootMargin: '50px' });
				}

				// no else, as these two if statements are no mutually exclusive
				if (el.className.indexOf('article-page') > -1) {
					metricsObserver.observe(el);
				}
			});

			[...self.$el.querySelectorAll('.article-page[data-page="1"]')].forEach((el) => {
				metricsObserverFirstPage.observe(el);
			});

			// Create articleObserver for infinite article
			this.createArticleObserver();
		} else {
			// eslint-disable-next-line
			if ((this.viewAllContent || (this.isSiteFronts && !this.isInteractivePage)) && ( this.clientWidth > 767 && !this.isNewTabSpec ) && !this.isPolicyCorp) {
				// eslint-disable-next-line
				const self = this;

				[...document.querySelectorAll('.article-page')].forEach((el) => {
					if (!(el.querySelector('.emb-center-well-ad'))) {
						const pageNum = el.getAttribute('data-page');
						const stwrapper = document.createElement('div');
						if (window.rrAdsNew === true && pageNum > 1) return;
						if ((this.isTablet || this.isEmbdAdFits) && !this.isNewTabSpec) {
							stwrapper.className = 'module ad emb-center-well-ad ad-923';
							stwrapper.id = `ad-centerwell-pos-923-${pageNum}`;
						} else {
							stwrapper.className = 'module ad emb-center-well-ad';
							stwrapper.id = `ad-centerwell-pos-141-${pageNum}`;
						}
						const sectionEle = `.article-page[data-page="${pageNum}"] section`;
						const arr = [...document.querySelectorAll(sectionEle)];
						if (arr && arr.length > 1) {
							self.placeElementInMiddle(el, stwrapper);
						}
					}
				});

				/* eslint-disable no-undef */
				if (window.webmd && window.webmd.ads && window.webmd.ads.disableAdsInit) {
					let checkVideoPlayerCount = 0;

					const interval = setInterval(() => {
						if (window.vueVideo) {
							clearInterval(interval);
							setTimeout(() => {
								this.unpaginatedArticleLoader.then((comp) => {
									comp.methods.load141AdOnceDisplayCalled();
								});
							}, 1000);
						}
						// eslint-disable-next-line no-plusplus
						if (++checkVideoPlayerCount === 10) {
							clearInterval(interval);
						}
					}, 1000);
				} else {
					this.unpaginatedArticleLoader.then((comp) => {
						if (this.isTablet || this.isEmbdAdFits) {
							this.load923Ad('ad-centerwell-pos-923-1');
						} else {
							comp.methods.load141Ad('ad-centerwell-pos-141-1');
						}
						window.setTimeout(() => {
							window.webmd.ads.setPageTarget('pg', 1);
							window.webmd.ads.refresh();
						}, 1000);
					});
				}
				this.unpaginatedArticleLoader.then(() => {
					if (window.rrAdsNew) {
						this.createRRTestadContainers();
						if (document.querySelector('.ads2-pos-121-rrt')) {
							const adContainer = document.querySelector('.ad-container-121');
							if (adContainer && !adContainer.classList.contains('ads2-pos-121-rrt')) {
								adContainer.classList.add('ads2-pos-121-rrt');
								adContainer.setAttribute('data-id', '1');
							}
							this.initObserverRRAds('.ads2-pos-121-rrt');
						}
					}
				});
			} else if (!this.isInteractivePage && !this.isPolicyCorp) {
				[...document.querySelectorAll('.article-page')].forEach((el) => {
					if (!(el.querySelector('.responsive-sharethrough-wrapper'))) {
						const stwrapper = document.createElement('div');
						stwrapper.className = 'responsive-sharethrough-wrapper';
						stwrapper.innerHTML = '<div class="responsive_sharethrough embed_asset_override reltd_article clearfix native_ad module embed-asset"></div>';
						this.placeElementInMiddle(el, stwrapper);
					}
				});
				const firstPageST = document.querySelector('.article-page[data-page="1"] .responsive_sharethrough');

				const stId = 'ads2-pos-923-responsive-sharethrough-ad-page-1-1';

				if (!(document.getElementById(stId))) {
					const d = document.createElement('div');
					d.id = stId;
					d.classList.add('module', 'ad', 'ad-923');

					firstPageST.appendChild(d);
					firstPageST.classList.add('ad-container-923', 'ad-wrapper');

					let adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
					adTargets.pg = '1';
					
					window.webmd.adsConsumer.defineAd({
						id: stId,
						pos: 1923,
						sizes: [1, 9],
						targets: adTargets,
						blockCodes: this.store.pagedata.ad.blockCodes,
						keys: { strnativekey: 'Vjx59uEm8EVWkMyP8f8smvF8' },
					});

					firstPageST.style.display = 'block';
				}
			}
		}

		// update jumplink hrefids
		this.updateJumplinkIds();

		if (!this.isInteractivePage) {
			const icmInterval = setInterval(() => {
				const icm = document.querySelectorAll('.ad-5000');

				if (icm && icm[0]) {
					clearInterval(icmInterval);
					self.placeIcm(1);
				}
			}, 200);
		}
		if (this.hasEmbeddedVideo) {
			if (this.embedVideoId && this.embedVideoId.length > 0) {
				createApp(this.videoComponentLoader, {
					chronicId: this.embedVideoId[0],
					mode: 'in-article',
				})
					.use(this.$pinia)
					.use(metric)
					.mount('.video-wrapper');
			}
			if (window.s_contains_video !== null && window.s_contains_video === 'in-article') {
				window.webmd.ads.setPageTarget('autply', '1');
			}
		}
		if (this.embededModuleObject) {
			const embededWrapperEle = document.createElement('div');
			embededWrapperEle.setAttribute('id', 'embedded-wrapper');
			document.querySelector('.article.medref').appendChild(embededWrapperEle);

			createApp({
				render: () => h(this.embededAssetsLoader),
			}, {
				'embed-modules': this.embededModuleObject,
				embedImageDisplay: false,
			})
				.use(this.$pinia)
				.mount('#embedded-wrapper');
		}

		const anchorTags = document.querySelectorAll('.article__body .article-page a');
		if (anchorTags) {
			/* eslint-disable no-param-reassign */
			anchorTags.forEach((el) => {
				let crosslinkAttribute;
				if (el.getAttribute('data-crosslink-type')) {
					crosslinkAttribute = el.getAttribute('data-crosslink-type').toLowerCase();
				}
				if (crosslinkAttribute) {
					if (crosslinkAttribute === 'slideshows' || crosslinkAttribute === 'videos') {
						crosslinkAttribute = crosslinkAttribute.substring(0, crosslinkAttribute.length - 1);
					}
					el.setAttribute('data-crosslink-type', crosslinkAttribute);
				}
				el = el.setAttribute('data-metrics-link', '');
			});
			/* eslint-enable no-param-reassign */
		}

		// Call the image collection method only when publication is image collection
		if (this.isImageCollection) {
			this.getImagecollection();
		}

		if (this.isPolicyCorp) {
			if (typeof (window) !== 'undefined') {
				window.ads_ignore = { all: true };
			}
		}

		self.handleOffsiteLinks();

		if (this.isSiteFronts) {
			this.moveSFInArticleNav();
		}

		/* Oncology specific configuration & setup */
		if (this.isOncology) {
			// Override the suggested module configuration for oncology
			if (window) {
				if (!window.unpaginatedOptions) {
					window.unpaginatedOptions = {};
				}
				window.unpaginatedOptions.numOfTopPicksSlots = 1;
				window.unpaginatedOptions.headerForTopPicks = 'Related:';
			}
		}

		if (this.qap) {
			window.ads_ignore = {
				...window.ads_ignore,
				9001: true,
				9002: true,
				9021: true,
				9022: true,
				9023: true,
				9024: true,
				9025: true,
				9026: true,
			};
		}
		const placeholderId = this.metadataModule.i_chronicle_id;
		const placeholderText = document.querySelectorAll(`[data-artid="${placeholderId}"] .article__body`)[0].innerText;
		if (this.store.pagedata.omniture.s_business_reference.toLowerCase() === 'feature') {
			this.hideReadMin = true;
			this.articleText = placeholderText;
			createApp(audioPlayer, { 'article-text': this.articleText }).use(this.$pinia).use(metric).mount(`#audio-placeholder-${placeholderId}`);
		}
		if (window.infiniteList && Object.keys(window.infiniteList).length === 1) {
			this.checkIfAdIsAvailable();
		}

		const desktopMetricsObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const pageNum = entry.target.dataset.page;
						if (entry.intersectionRect.top === 0) {
							self.$vwmddpv({
								moduleName: 'pg-n-swipe-up',
								pageName: document.location.href.replace(/[\?#].*/, ''),
								iCount: pageNum,
								refresh: false,
							});
							if (!window.rrAdsNew) {
								this.loadDesktopAds(pageNum, 'u');
							}
						} else {
							self.$vwmddpv({
								moduleName: 'pg-n-swipe',
								pageName: document.location.href.replace(/[\?#].*/, ''),
								iCount: pageNum,
								refresh: false,
							});
							if (!window.rrAdsNew && this.isTopAdlazyLoaded) {
								this.loadDesktopAds(pageNum, '');
							}
						}
					}
				});
		});
		if (this.clientWidth > 1024) {
			[...self.$el.querySelectorAll('.article-page')].forEach((el) => {
				// no else, as these two if statements are no mutually exclusive
				if (el.className.indexOf('article-page') > -1) {
					desktopMetricsObserver.observe(el);
				}
			});
		}
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss">
@import 'stylesheets/main.scss';
@import 'stylesheets/nojs.scss';
@import 'stylesheets/qap.scss';
@import 'stylesheets/embstyles.scss';
@import 'stylesheets/oncology-medref.scss';
@import 'stylesheets/print-styles.scss';
</style>
